import * as z from 'zod';

export const SubmitJobRequest = (() => {
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
        }),
        z.object({
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          fieldPath: z
            .string()
            .describe(
              'Path to the field containing the value to resolve.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`.'
            )
            .max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          text: z.string().describe('Text value.').max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          numeric: z.number().describe('Number value.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          add: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Adds the specified expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          sum: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Calculates the total sum of multiple expressions.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          subtract: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract `secondExpression` from.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract from `firstExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Subtracts 1 expression from another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          multiply: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Multiplies multiple expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          divide: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe('Divides 1 expression by another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          abs: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to find the absolute value of.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Finds the absolute value of an expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          mod: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression` to find the remainder.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe(
              'Finds the remainder when dividing 1 expression by another.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          floor: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round down to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression down to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          ceil: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round up to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression up to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          concat: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Joins multiple expressions together to create a string.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          stringify: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe('Expression to convert to a string.')
                .optional(),
            })
            .describe('Converts an expression to a string.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toLower: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to lowercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to lowercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toUpper: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to uppercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to uppercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          length: z.never().optional(),
          substring: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to extract a substring from.\n\nExpression must resolve to a string.'
                )
                .optional(),
              startExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Starting position of the substring to extract, specified in zero-based indexing.\n\nExpression must resolve to a number.'
                )
                .optional(),
              lengthExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Number of characters to extract from the starting position.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Extracts a portion of a string expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to count the total number of characters of.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Finds the length of a string expression.'),
        }),
      ])
    );
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
        }),
        z.object({
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          include: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to include in the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, includes only the specified field in the result. All other fields are excluded.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          exclude: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to exclude from the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, excludes the specified field from the result. All other fields are included.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          projectNested: z.never().optional(),
          reshape: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the field to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              expression:
                comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  .describe(
                    'Expression to resolve. The result of the expression becomes the value of the new field.'
                  )
                  .optional(),
            })
            .describe(
              'Reshapes a new field based on the specified expression. The field used by the expression is not included in the result.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the parent field for the nested fields.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              fields: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Creates nested fields by including, excluding, or reshaping fields.'
            ),
        }),
      ])
    );
  return z.object({
    source: z
      .intersection(
        z.object({}),
        z.xor([
          z.object({
            localization: z.never().optional(),
            file: z.never().optional(),
            wixDataCollection: z
              .intersection(
                z.object({
                  collectionId: z
                    .string()
                    .describe('ID of the data collection.')
                    .min(1)
                    .max(256)
                    .optional(),
                  filter: z
                    .record(z.string(), z.any())
                    .describe(
                      'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).\nDeprecated: Use `filter_query.filter` instead.'
                    )
                    .optional()
                    .nullable(),
                  fields: z.array(z.string()).optional(),
                }),
                z.xor([
                  z.object({
                    filterQuery: z.never().optional(),
                    aggregationQuery: z.never().optional(),
                  }),
                  z.object({
                    aggregationQuery: z.never().optional(),
                    filterQuery: z
                      .object({
                        filter: z
                          .record(z.string(), z.any())
                          .describe(
                            'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).'
                          )
                          .optional()
                          .nullable(),
                        fields: z.array(z.string()).optional(),
                      })
                      .describe(
                        'Filter and field selection to apply to the collection items.'
                      ),
                  }),
                  z.object({
                    filterQuery: z.never().optional(),
                    aggregationQuery: z
                      .object({
                        aggregationPipeline: z
                          .intersection(
                            z.object({
                              stages: z
                                .array(
                                  z.intersection(
                                    z.object({}),
                                    z.xor([
                                      z.object({
                                        group: z.never().optional(),
                                        filter: z.never().optional(),
                                        sort: z.never().optional(),
                                        projection: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z.never().optional(),
                                      }),
                                      z.object({
                                        filter: z.never().optional(),
                                        sort: z.never().optional(),
                                        projection: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z.never().optional(),
                                        group: z
                                          .object({
                                            groupIds: z
                                              .array(
                                                z.object({
                                                  key: z
                                                    .string()
                                                    .describe(
                                                      "Name of the field to group items by.\n\nThis becomes the field name in the result's `_id` property."
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                  expression:
                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                      .describe(
                                                        "Expression to determine the grouping value. Items whose expression resolves to the same value are grouped together in the result item's `_id` property."
                                                      )
                                                      .optional(),
                                                })
                                              )
                                              .max(1000)
                                              .optional(),
                                            accumulators: z
                                              .array(
                                                z.intersection(
                                                  z.object({
                                                    resultFieldName: z
                                                      .string()
                                                      .describe(
                                                        'Field key in the output item to store the result in.'
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  }),
                                                  z.xor([
                                                    z.object({
                                                      avg: z.never().optional(),
                                                      min: z.never().optional(),
                                                      max: z.never().optional(),
                                                      sum: z.never().optional(),
                                                      first: z
                                                        .never()
                                                        .optional(),
                                                      last: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .never()
                                                        .optional(),
                                                    }),
                                                    z.object({
                                                      min: z.never().optional(),
                                                      max: z.never().optional(),
                                                      sum: z.never().optional(),
                                                      first: z
                                                        .never()
                                                        .optional(),
                                                      last: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .never()
                                                        .optional(),
                                                      avg: z
                                                        .object({
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                "Expression to calculate the group's average value.\n\nExpression must resolve to a number."
                                                              )
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          'Calculates the average value across all items in the group based on the specified expression.'
                                                        ),
                                                    }),
                                                    z.object({
                                                      avg: z.never().optional(),
                                                      max: z.never().optional(),
                                                      sum: z.never().optional(),
                                                      first: z
                                                        .never()
                                                        .optional(),
                                                      last: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .never()
                                                        .optional(),
                                                      min: z
                                                        .object({
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                "Expression to find the group's minimum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                              )
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          'Finds the minimum value across all items in the group.'
                                                        ),
                                                    }),
                                                    z.object({
                                                      avg: z.never().optional(),
                                                      min: z.never().optional(),
                                                      sum: z.never().optional(),
                                                      first: z
                                                        .never()
                                                        .optional(),
                                                      last: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .never()
                                                        .optional(),
                                                      max: z
                                                        .object({
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                "Expression to find the group's maximum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                              )
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          'Finds the maximum value across all items in the group.'
                                                        ),
                                                    }),
                                                    z.object({
                                                      avg: z.never().optional(),
                                                      min: z.never().optional(),
                                                      max: z.never().optional(),
                                                      first: z
                                                        .never()
                                                        .optional(),
                                                      last: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .never()
                                                        .optional(),
                                                      sum: z
                                                        .object({
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                "Expression to calculate the group's total sum.\n\nExpression must resolve to a number."
                                                              )
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          'Calculates the sum of the specified expression across all items in the group.'
                                                        ),
                                                    }),
                                                    z.object({
                                                      avg: z.never().optional(),
                                                      min: z.never().optional(),
                                                      max: z.never().optional(),
                                                      sum: z.never().optional(),
                                                      last: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .never()
                                                        .optional(),
                                                      first: z
                                                        .object({
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                'Expression to find the first item in the group.'
                                                              )
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          'Finds the first item in the group.'
                                                        ),
                                                    }),
                                                    z.object({
                                                      avg: z.never().optional(),
                                                      min: z.never().optional(),
                                                      max: z.never().optional(),
                                                      sum: z.never().optional(),
                                                      first: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .never()
                                                        .optional(),
                                                      last: z
                                                        .object({
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                'Expression to find the last item in the group.'
                                                              )
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          'Finds the last item in the group.'
                                                        ),
                                                    }),
                                                    z.object({
                                                      avg: z.never().optional(),
                                                      min: z.never().optional(),
                                                      max: z.never().optional(),
                                                      sum: z.never().optional(),
                                                      first: z
                                                        .never()
                                                        .optional(),
                                                      last: z
                                                        .never()
                                                        .optional(),
                                                      push: z
                                                        .object({
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                'Expression to collect items into an array.'
                                                              )
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          'Collects values from all items in the group into an array.'
                                                        ),
                                                    }),
                                                  ])
                                                )
                                              )
                                              .max(1000)
                                              .optional(),
                                          })
                                          .describe(
                                            'Groups aggregated items to new result items.'
                                          ),
                                      }),
                                      z.object({
                                        group: z.never().optional(),
                                        sort: z.never().optional(),
                                        projection: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z.never().optional(),
                                        filter: z
                                          .record(z.string(), z.any())
                                          .describe(
                                            'Aggregation filter. Only items that match the filter are processed.\n\nLearn more about [filters in API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).\n\n> **Note:** The values you provide for each filter field must adhere to that field\'s data type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).'
                                          ),
                                      }),
                                      z.object({
                                        group: z.never().optional(),
                                        filter: z.never().optional(),
                                        projection: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z.never().optional(),
                                        sort: z
                                          .object({
                                            values: z
                                              .array(
                                                z.object({
                                                  fieldName: z
                                                    .string()
                                                    .describe(
                                                      'Name of the field to sort by.'
                                                    )
                                                    .min(1)
                                                    .max(1000)
                                                    .optional(),
                                                  order: z
                                                    .enum(['ASC', 'DESC'])
                                                    .optional(),
                                                })
                                              )
                                              .max(1000)
                                              .optional(),
                                          })
                                          .describe(
                                            'Sorting preferences.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                          ),
                                      }),
                                      z.object({
                                        group: z.never().optional(),
                                        filter: z.never().optional(),
                                        sort: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z.never().optional(),
                                        projection: z
                                          .object({
                                            fields: z
                                              .array(
                                                comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                                              )
                                              .max(1000)
                                              .optional(),
                                          })
                                          .describe(
                                            'Transforms items by including, excluding, or reshaping fields.'
                                          ),
                                      }),
                                      z.object({
                                        group: z.never().optional(),
                                        filter: z.never().optional(),
                                        sort: z.never().optional(),
                                        projection: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z.never().optional(),
                                        objectToArray: z
                                          .object({
                                            objectFieldName: z
                                              .string()
                                              .describe(
                                                'Key of the object field to convert to an array.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                              )
                                              .max(1000)
                                              .optional(),
                                            destinationFieldName: z
                                              .string()
                                              .describe(
                                                'Key of the new array to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                              )
                                              .max(1000)
                                              .optional(),
                                          })
                                          .describe(
                                            "Transforms an object into an array where each object property becomes a new array element containing the property's key and value, as well as all other properties from the original object."
                                          ),
                                      }),
                                      z.object({
                                        group: z.never().optional(),
                                        filter: z.never().optional(),
                                        sort: z.never().optional(),
                                        projection: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z.never().optional(),
                                        unwindArray: z
                                          .object({
                                            arrayFieldName: z
                                              .string()
                                              .describe(
                                                'Key of the array field to unwind.\n\nUse dot notation to specify a nested array. For example, `user.products` or `product.colors`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                              )
                                              .max(1000)
                                              .optional(),
                                          })
                                          .describe(
                                            'Creates a result item for each array element. Each result contains the full original item, with the array field replaced by an element whose key is the array name and whose value is the array element.'
                                          ),
                                      }),
                                      z.object({
                                        group: z.never().optional(),
                                        filter: z.never().optional(),
                                        sort: z.never().optional(),
                                        projection: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        limit: z.never().optional(),
                                        skip: z
                                          .number()
                                          .int()
                                          .describe(
                                            'Number of results to skip from the beginning of the result set.'
                                          ),
                                      }),
                                      z.object({
                                        group: z.never().optional(),
                                        filter: z.never().optional(),
                                        sort: z.never().optional(),
                                        projection: z.never().optional(),
                                        objectToArray: z.never().optional(),
                                        unwindArray: z.never().optional(),
                                        skip: z.never().optional(),
                                        limit: z
                                          .number()
                                          .int()
                                          .describe(
                                            'Maximum number of results to return.'
                                          ),
                                      }),
                                    ])
                                  )
                                )
                                .max(100)
                                .optional(),
                            }),
                            z.xor([
                              z.object({
                                paging: z.never().optional(),
                                cursorPaging: z.never().optional(),
                              }),
                              z.object({
                                cursorPaging: z.never().optional(),
                                paging: z
                                  .object({
                                    limit: z
                                      .number()
                                      .int()
                                      .describe('Number of items to load.')
                                      .min(0)
                                      .optional()
                                      .nullable(),
                                    offset: z
                                      .number()
                                      .int()
                                      .describe(
                                        'Number of items to skip in the current sort order.'
                                      )
                                      .min(0)
                                      .optional()
                                      .nullable(),
                                  })
                                  .describe(
                                    'Paging options to limit and skip the number of results.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                  ),
                              }),
                              z.object({
                                paging: z.never().optional(),
                                cursorPaging: z
                                  .object({
                                    limit: z
                                      .number()
                                      .int()
                                      .describe('Number of items to load.')
                                      .min(0)
                                      .max(1000)
                                      .optional()
                                      .nullable(),
                                    cursor: z
                                      .string()
                                      .describe(
                                        "Pointer to the next or previous page in the list of results.\n\nYou can get the relevant cursor token\nfrom the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                                      )
                                      .max(150000)
                                      .optional()
                                      .nullable(),
                                  })
                                  .describe(
                                    'Cursor token referring to a page of results.\n\nNot used in the first request. Subsequent requests use the cursor token and not `filter` or `sort`.'
                                  ),
                              }),
                            ])
                          )
                          .describe(
                            'Aggregation pipeline to run on the collection.'
                          )
                          .optional(),
                        fields: z
                          .array(
                            z.object({
                              key: z
                                .string()
                                .describe(
                                  'Field ID.\n\nIf the field type is `Array`, specify the item index. If the field type is `Object`, specify the field path. Use dot notation to specify nested fields, for example: `data.address.city`.'
                                )
                                .max(1024)
                                .optional(),
                              displayName: z
                                .string()
                                .describe(
                                  'Field display name.\n\nWhen moving items to CSV files, use this to set the header of the target column.'
                                )
                                .max(1024)
                                .optional(),
                              fieldType: z
                                .enum([
                                  'ANY',
                                  'STRING',
                                  'NUMBER',
                                  'BOOLEAN',
                                  'DATE',
                                  'DATETIME',
                                  'BINARY',
                                  'OBJECT',
                                  'ARRAY',
                                  'URL',
                                  'WIX_MEDIA_URL',
                                  'WIX_MEDIA_IMAGE_URL',
                                  'WIX_MEDIA_VIDEO_URL',
                                  'WIX_MEDIA_DOCUMENT_URL',
                                  'IMAGE_URL',
                                  'VIDEO_URL',
                                ])
                                .optional(),
                            })
                          )
                          .min(0)
                          .max(1000)
                          .optional(),
                      })
                      .describe(
                        'Aggregation pipeline to run on the collection.'
                      ),
                  }),
                ])
              )
              .describe(
                'Wix data collection.\n\nYou can move items from native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
              ),
          }),
          z.object({
            wixDataCollection: z.never().optional(),
            file: z.never().optional(),
            localization: z
              .object({
                languages: z.array(z.string()).min(2).max(64).optional(),
              })
              .describe(
                'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
              ),
          }),
          z.object({
            wixDataCollection: z.never().optional(),
            localization: z.never().optional(),
            file: z
              .object({
                format: z.enum(['UNKNOWN', 'CSV', 'JSONL']).optional(),
                fileId: z
                  .string()
                  .describe(
                    "File ID as returned in the `fileId` property of the Create File Upload URL method's response."
                  )
                  .max(512)
                  .optional(),
                url: z
                  .string()
                  .describe(
                    'URL where the source file is uploaded. Automatically generated by Wix.'
                  )
                  .max(2048)
                  .optional(),
              })
              .describe(
                'Source file.\n\nYou can import data from files in CSV or JSONL formats. Uploading a file with an invalid format causes the movement job to fail.\n\nTo upload a file, call Create File Upload Url ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/movement-jobs/create-file-upload-url) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-movement-jobs/create-file-upload-url)) and use the `uploadUrl` from the response. For example:\n\n`curl --request PUT --upload-file "${path_to_file}" "${uploadUrl}"`'
              ),
          }),
        ])
      )
      .describe('Source to move data from.'),
    destination: z
      .intersection(
        z.object({}),
        z.xor([
          z.object({
            localization: z.never().optional(),
            file: z.never().optional(),
            wixDataCollection: z
              .object({
                collectionId: z
                  .string()
                  .describe('ID of the destination collection.')
                  .max(256)
                  .optional(),
                writePolicy: z
                  .enum(['OVERWRITE', 'SKIP_EXISTING', 'TRUNCATE_BEFORE'])
                  .optional(),
              })
              .describe(
                'Wix data collection.\n\nYou can move items to native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
              ),
          }),
          z.object({
            wixDataCollection: z.never().optional(),
            file: z.never().optional(),
            localization: z
              .object({
                languages: z.array(z.string()).min(2).max(64).optional(),
              })
              .describe(
                'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
              ),
          }),
          z.object({
            wixDataCollection: z.never().optional(),
            localization: z.never().optional(),
            file: z
              .object({
                format: z.enum(['UNKNOWN', 'CSV', 'JSONL']).optional(),
                fileName: z
                  .string()
                  .describe('File name.')
                  .max(512)
                  .optional()
                  .nullable(),
                url: z
                  .string()
                  .describe('File download URL.')
                  .max(2048)
                  .optional(),
              })
              .describe('Downloadable file with the moved items.'),
          }),
        ])
      )
      .describe('Destination to move data to.'),
    options: z
      .intersection(
        z.object({ name: z.string().describe('Job name.').optional() }),
        z.xor([
          z.object({
            sourceSiteId: z.never().optional(),
            destinationSiteId: z.never().optional(),
          }),
          z.object({
            destinationSiteId: z.never().optional(),
            sourceSiteId: z
              .string()
              .describe(
                'When moving data from the Wix data collection of a site other than the current one, the source site ID.\n\nBy default, the source site is the current site. However, you can move data from any site in the same [Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account).\n\n> **Note**: You can specify the ID of another source site or destination site, but not both.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              ),
          }),
          z.object({
            sourceSiteId: z.never().optional(),
            destinationSiteId: z
              .string()
              .describe(
                'When moving data to the Wix data collection of a site other than the current one, the destination site ID.\n\nBy default, the destination site is the current site. However, you can move data to any site in the same [Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account) by specifying its ID. You can retrieve this ID by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of another source site or destination site, but not both.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              ),
          }),
        ])
      )
      .optional(),
  });
})();
export const SubmitJobResponse = (() => {
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
        }),
        z.object({
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          fieldPath: z
            .string()
            .describe(
              'Path to the field containing the value to resolve.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`.'
            )
            .max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          text: z.string().describe('Text value.').max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          numeric: z.number().describe('Number value.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          add: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Adds the specified expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          sum: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Calculates the total sum of multiple expressions.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          subtract: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract `secondExpression` from.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract from `firstExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Subtracts 1 expression from another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          multiply: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Multiplies multiple expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          divide: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe('Divides 1 expression by another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          abs: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to find the absolute value of.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Finds the absolute value of an expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          mod: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression` to find the remainder.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe(
              'Finds the remainder when dividing 1 expression by another.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          floor: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round down to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression down to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          ceil: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round up to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression up to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          concat: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Joins multiple expressions together to create a string.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          stringify: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe('Expression to convert to a string.')
                .optional(),
            })
            .describe('Converts an expression to a string.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toLower: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to lowercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to lowercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toUpper: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to uppercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to uppercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          length: z.never().optional(),
          substring: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to extract a substring from.\n\nExpression must resolve to a string.'
                )
                .optional(),
              startExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Starting position of the substring to extract, specified in zero-based indexing.\n\nExpression must resolve to a number.'
                )
                .optional(),
              lengthExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Number of characters to extract from the starting position.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Extracts a portion of a string expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to count the total number of characters of.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Finds the length of a string expression.'),
        }),
      ])
    );
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
        }),
        z.object({
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          include: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to include in the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, includes only the specified field in the result. All other fields are excluded.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          exclude: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to exclude from the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, excludes the specified field from the result. All other fields are included.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          projectNested: z.never().optional(),
          reshape: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the field to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              expression:
                comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  .describe(
                    'Expression to resolve. The result of the expression becomes the value of the new field.'
                  )
                  .optional(),
            })
            .describe(
              'Reshapes a new field based on the specified expression. The field used by the expression is not included in the result.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the parent field for the nested fields.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              fields: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Creates nested fields by including, excluding, or reshaping fields.'
            ),
        }),
      ])
    );
  return z.object({
    job: z
      .intersection(
        z.object({
          _id: z
            .string()
            .describe('Job ID.')
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional(),
          startedAt: z
            .date()
            .describe('When the job was submitted.')
            .optional()
            .nullable(),
          status: z
            .enum([
              'UNINITIALIZED',
              'INITIALIZING',
              'IN_PROGRESS',
              'COMPLETED',
              'FAILED',
              'PARTIALLY_SUCCESSFUL',
            ])
            .describe('Current job status.')
            .optional(),
          source: z
            .intersection(
              z.object({}),
              z.xor([
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z.never().optional(),
                }),
                z.object({
                  localization: z.never().optional(),
                  file: z.never().optional(),
                  wixDataCollection: z
                    .intersection(
                      z.object({
                        collectionId: z
                          .string()
                          .describe('ID of the data collection.')
                          .min(1)
                          .max(256)
                          .optional(),
                        filter: z
                          .record(z.string(), z.any())
                          .describe(
                            'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).\nDeprecated: Use `filter_query.filter` instead.'
                          )
                          .optional()
                          .nullable(),
                        fields: z.array(z.string()).optional(),
                      }),
                      z.xor([
                        z.object({
                          filterQuery: z.never().optional(),
                          aggregationQuery: z.never().optional(),
                        }),
                        z.object({
                          aggregationQuery: z.never().optional(),
                          filterQuery: z
                            .object({
                              filter: z
                                .record(z.string(), z.any())
                                .describe(
                                  'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).'
                                )
                                .optional()
                                .nullable(),
                              fields: z.array(z.string()).optional(),
                            })
                            .describe(
                              'Filter and field selection to apply to the collection items.'
                            ),
                        }),
                        z.object({
                          filterQuery: z.never().optional(),
                          aggregationQuery: z
                            .object({
                              aggregationPipeline: z
                                .intersection(
                                  z.object({
                                    stages: z
                                      .array(
                                        z.intersection(
                                          z.object({}),
                                          z.xor([
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                            }),
                                            z.object({
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              group: z
                                                .object({
                                                  groupIds: z
                                                    .array(
                                                      z.object({
                                                        key: z
                                                          .string()
                                                          .describe(
                                                            "Name of the field to group items by.\n\nThis becomes the field name in the result's `_id` property."
                                                          )
                                                          .max(1000)
                                                          .optional(),
                                                        expression:
                                                          comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                            .describe(
                                                              "Expression to determine the grouping value. Items whose expression resolves to the same value are grouped together in the result item's `_id` property."
                                                            )
                                                            .optional(),
                                                      })
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                  accumulators: z
                                                    .array(
                                                      z.intersection(
                                                        z.object({
                                                          resultFieldName: z
                                                            .string()
                                                            .describe(
                                                              'Field key in the output item to store the result in.'
                                                            )
                                                            .max(1000)
                                                            .optional(),
                                                        }),
                                                        z.xor([
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                          }),
                                                          z.object({
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            avg: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to calculate the group's average value.\n\nExpression must resolve to a number."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Calculates the average value across all items in the group based on the specified expression.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to find the group's minimum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the minimum value across all items in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to find the group's maximum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the maximum value across all items in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to calculate the group's total sum.\n\nExpression must resolve to a number."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Calculates the sum of the specified expression across all items in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      'Expression to find the first item in the group.'
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the first item in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      'Expression to find the last item in the group.'
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the last item in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      'Expression to collect items into an array.'
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Collects values from all items in the group into an array.'
                                                              ),
                                                          }),
                                                        ])
                                                      )
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Groups aggregated items to new result items.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              filter: z
                                                .record(z.string(), z.any())
                                                .describe(
                                                  'Aggregation filter. Only items that match the filter are processed.\n\nLearn more about [filters in API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).\n\n> **Note:** The values you provide for each filter field must adhere to that field\'s data type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              sort: z
                                                .object({
                                                  values: z
                                                    .array(
                                                      z.object({
                                                        fieldName: z
                                                          .string()
                                                          .describe(
                                                            'Name of the field to sort by.'
                                                          )
                                                          .min(1)
                                                          .max(1000)
                                                          .optional(),
                                                        order: z
                                                          .enum(['ASC', 'DESC'])
                                                          .describe(
                                                            'Sort order.'
                                                          )
                                                          .optional(),
                                                      })
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Sorting preferences.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              projection: z
                                                .object({
                                                  fields: z
                                                    .array(
                                                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Transforms items by including, excluding, or reshaping fields.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              objectToArray: z
                                                .object({
                                                  objectFieldName: z
                                                    .string()
                                                    .describe(
                                                      'Key of the object field to convert to an array.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                  destinationFieldName: z
                                                    .string()
                                                    .describe(
                                                      'Key of the new array to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Transforms an object into an array where each object property becomes a new array element containing the property's key and value, as well as all other properties from the original object."
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              unwindArray: z
                                                .object({
                                                  arrayFieldName: z
                                                    .string()
                                                    .describe(
                                                      'Key of the array field to unwind.\n\nUse dot notation to specify a nested array. For example, `user.products` or `product.colors`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Creates a result item for each array element. Each result contains the full original item, with the array field replaced by an element whose key is the array name and whose value is the array element.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              limit: z.never().optional(),
                                              skip: z
                                                .number()
                                                .int()
                                                .describe(
                                                  'Number of results to skip from the beginning of the result set.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z
                                                .number()
                                                .int()
                                                .describe(
                                                  'Maximum number of results to return.'
                                                ),
                                            }),
                                          ])
                                        )
                                      )
                                      .max(100)
                                      .optional(),
                                  }),
                                  z.xor([
                                    z.object({
                                      paging: z.never().optional(),
                                      cursorPaging: z.never().optional(),
                                    }),
                                    z.object({
                                      cursorPaging: z.never().optional(),
                                      paging: z
                                        .object({
                                          limit: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Number of items to load.'
                                            )
                                            .min(0)
                                            .optional()
                                            .nullable(),
                                          offset: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Number of items to skip in the current sort order.'
                                            )
                                            .min(0)
                                            .optional()
                                            .nullable(),
                                        })
                                        .describe(
                                          'Paging options to limit and skip the number of results.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                        ),
                                    }),
                                    z.object({
                                      paging: z.never().optional(),
                                      cursorPaging: z
                                        .object({
                                          limit: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Number of items to load.'
                                            )
                                            .min(0)
                                            .max(1000)
                                            .optional()
                                            .nullable(),
                                          cursor: z
                                            .string()
                                            .describe(
                                              "Pointer to the next or previous page in the list of results.\n\nYou can get the relevant cursor token\nfrom the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                                            )
                                            .max(150000)
                                            .optional()
                                            .nullable(),
                                        })
                                        .describe(
                                          'Cursor token referring to a page of results.\n\nNot used in the first request. Subsequent requests use the cursor token and not `filter` or `sort`.'
                                        ),
                                    }),
                                  ])
                                )
                                .describe(
                                  'Aggregation pipeline to run on the collection.'
                                )
                                .optional(),
                              fields: z
                                .array(
                                  z.object({
                                    key: z
                                      .string()
                                      .describe(
                                        'Field ID.\n\nIf the field type is `Array`, specify the item index. If the field type is `Object`, specify the field path. Use dot notation to specify nested fields, for example: `data.address.city`.'
                                      )
                                      .max(1024)
                                      .optional(),
                                    displayName: z
                                      .string()
                                      .describe(
                                        'Field display name.\n\nWhen moving items to CSV files, use this to set the header of the target column.'
                                      )
                                      .max(1024)
                                      .optional(),
                                    fieldType: z
                                      .enum([
                                        'ANY',
                                        'STRING',
                                        'NUMBER',
                                        'BOOLEAN',
                                        'DATE',
                                        'DATETIME',
                                        'BINARY',
                                        'OBJECT',
                                        'ARRAY',
                                        'URL',
                                        'WIX_MEDIA_URL',
                                        'WIX_MEDIA_IMAGE_URL',
                                        'WIX_MEDIA_VIDEO_URL',
                                        'WIX_MEDIA_DOCUMENT_URL',
                                        'IMAGE_URL',
                                        'VIDEO_URL',
                                      ])
                                      .describe(
                                        'Field data type. Default: `ANY`.\n\nLearn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).'
                                      )
                                      .optional(),
                                  })
                                )
                                .min(0)
                                .max(1000)
                                .optional(),
                            })
                            .describe(
                              'Aggregation pipeline to run on the collection.'
                            ),
                        }),
                      ])
                    )
                    .describe(
                      'Wix data collection.\n\nYou can move items from native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  file: z.never().optional(),
                  localization: z
                    .object({
                      languages: z.array(z.string()).min(2).max(64).optional(),
                    })
                    .describe(
                      'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z
                    .object({
                      format: z
                        .enum(['UNKNOWN', 'CSV', 'JSONL'])
                        .describe(
                          'File format. If not specified, automatically determined by Wix.'
                        )
                        .optional(),
                      fileId: z
                        .string()
                        .describe(
                          "File ID as returned in the `fileId` property of the Create File Upload URL method's response."
                        )
                        .max(512)
                        .optional(),
                      url: z
                        .string()
                        .describe(
                          'URL where the source file is uploaded. Automatically generated by Wix.'
                        )
                        .max(2048)
                        .optional(),
                    })
                    .describe(
                      'Source file.\n\nYou can import data from files in CSV or JSONL formats. Uploading a file with an invalid format causes the movement job to fail.\n\nTo upload a file, call Create File Upload Url ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/movement-jobs/create-file-upload-url) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-movement-jobs/create-file-upload-url)) and use the `uploadUrl` from the response. For example:\n\n`curl --request PUT --upload-file "${path_to_file}" "${uploadUrl}"`'
                    ),
                }),
              ])
            )
            .describe('Source to move data from.')
            .optional(),
          destination: z
            .intersection(
              z.object({}),
              z.xor([
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z.never().optional(),
                }),
                z.object({
                  localization: z.never().optional(),
                  file: z.never().optional(),
                  wixDataCollection: z
                    .object({
                      collectionId: z
                        .string()
                        .describe('ID of the destination collection.')
                        .max(256)
                        .optional(),
                      writePolicy: z
                        .enum(['OVERWRITE', 'SKIP_EXISTING', 'TRUNCATE_BEFORE'])
                        .describe(
                          'When items already exist in the destination collection, the data writing policy.\n\nDefault: `OVERWRITE`.'
                        )
                        .optional(),
                    })
                    .describe(
                      'Wix data collection.\n\nYou can move items to native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  file: z.never().optional(),
                  localization: z
                    .object({
                      languages: z.array(z.string()).min(2).max(64).optional(),
                    })
                    .describe(
                      'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z
                    .object({
                      format: z
                        .enum(['UNKNOWN', 'CSV', 'JSONL'])
                        .describe('File format.')
                        .optional(),
                      fileName: z
                        .string()
                        .describe('File name.')
                        .max(512)
                        .optional()
                        .nullable(),
                      url: z
                        .string()
                        .describe('File download URL.')
                        .max(2048)
                        .optional(),
                    })
                    .describe('Downloadable file with the moved items.'),
                }),
              ])
            )
            .describe('Destination to move data to.')
            .optional(),
          name: z.string().describe('Job name.').max(1024).optional(),
          progress: z
            .object({
              current: z
                .number()
                .int()
                .describe('Number of units already processed.')
                .optional(),
              total: z
                .number()
                .int()
                .describe('Total number of units to move.')
                .optional()
                .nullable(),
              itemsRejected: z
                .number()
                .int()
                .describe(
                  'Number of items that failed to move to the destination.'
                )
                .optional(),
              itemsSuccessful: z
                .number()
                .int()
                .describe(
                  'Number of items successfully moved to the destination.'
                )
                .optional(),
            })
            .describe(
              'When the job `status` is `IN_PROGRESS`, the progress details.'
            )
            .optional(),
          finishedAt: z
            .date()
            .describe(
              'Job finish time.\n\nA job is considered finished when its `status` updates to `COMPLETED`, `FAILED`, or `PARTIALLY_SUCCESSFUL`.'
            )
            .optional()
            .nullable(),
          error: z
            .object({
              code: z.string().describe('Error code.').optional(),
              description: z
                .string()
                .describe('Description of the error.')
                .optional(),
              data: z
                .record(z.string(), z.any())
                .describe('Data related to the error.')
                .optional()
                .nullable(),
            })
            .describe('Error information.')
            .optional(),
          sourceSiteId: z
            .string()
            .describe(
              'When moving data from a Wix data collection, the source site ID.\n\nBy default, the source site is the current site. To move data from [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional(),
          destinationSiteId: z
            .string()
            .describe(
              'When moving data to a Wix data collection, the destination site ID.\n\nBy default, the destination site is the current site. To move data to [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional(),
          logsRecorded: z
            .number()
            .int()
            .describe('Number of recorded logs.')
            .optional(),
          scheduleId: z
            .string()
            .describe(
              'Sync Schedule ID, if the job was triggered by a sync schedule.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          extendedFields: z
            .object({
              namespaces: z
                .record(z.string(), z.record(z.string(), z.any()))
                .describe(
                  'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
                )
                .optional(),
            })
            .describe(
              'Extended fields for custom metadata added by applications.'
            )
            .optional(),
          workflowId: z
            .string()
            .describe(
              'Workflow ID, if the job was created as a child step of a workflow.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
        }),
        z.xor([
          z.object({ partiallySuccessfulOptions: z.never().optional() }),
          z.object({
            partiallySuccessfulOptions: z
              .object({
                cause: z
                  .string()
                  .describe('Reason the job was partially successful.')
                  .max(1000)
                  .optional(),
              })
              .describe(
                "When the job's `status` is `PARTIALLY_SUCCESSFUL`, the additional details."
              ),
          }),
        ])
      )
      .describe('Details of the submitted job.')
      .optional(),
  });
})();
export const CreateFileUploadUrlRequest = z.object({
  options: z
    .object({
      fileName: z
        .string()
        .describe('Name of uploaded file.')
        .max(512)
        .optional()
        .nullable(),
    })
    .optional(),
});
export const CreateFileUploadUrlResponse = z.object({
  fileId: z.string().describe('File ID.').max(512).optional(),
  uploadUrl: z
    .string()
    .describe('URL to which you can upload the file.')
    .max(8192)
    .optional(),
});
export const GetJobRequest = z.object({
  jobId: z
    .string()
    .describe('Job ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const GetJobResponse = (() => {
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
        }),
        z.object({
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          fieldPath: z
            .string()
            .describe(
              'Path to the field containing the value to resolve.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`.'
            )
            .max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          text: z.string().describe('Text value.').max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          numeric: z.number().describe('Number value.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          add: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Adds the specified expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          sum: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Calculates the total sum of multiple expressions.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          subtract: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract `secondExpression` from.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract from `firstExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Subtracts 1 expression from another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          multiply: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Multiplies multiple expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          divide: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe('Divides 1 expression by another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          abs: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to find the absolute value of.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Finds the absolute value of an expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          mod: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression` to find the remainder.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe(
              'Finds the remainder when dividing 1 expression by another.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          floor: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round down to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression down to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          ceil: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round up to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression up to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          concat: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Joins multiple expressions together to create a string.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          stringify: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe('Expression to convert to a string.')
                .optional(),
            })
            .describe('Converts an expression to a string.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toLower: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to lowercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to lowercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toUpper: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to uppercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to uppercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          length: z.never().optional(),
          substring: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to extract a substring from.\n\nExpression must resolve to a string.'
                )
                .optional(),
              startExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Starting position of the substring to extract, specified in zero-based indexing.\n\nExpression must resolve to a number.'
                )
                .optional(),
              lengthExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Number of characters to extract from the starting position.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Extracts a portion of a string expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to count the total number of characters of.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Finds the length of a string expression.'),
        }),
      ])
    );
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
        }),
        z.object({
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          include: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to include in the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, includes only the specified field in the result. All other fields are excluded.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          exclude: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to exclude from the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, excludes the specified field from the result. All other fields are included.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          projectNested: z.never().optional(),
          reshape: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the field to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              expression:
                comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  .describe(
                    'Expression to resolve. The result of the expression becomes the value of the new field.'
                  )
                  .optional(),
            })
            .describe(
              'Reshapes a new field based on the specified expression. The field used by the expression is not included in the result.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the parent field for the nested fields.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              fields: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Creates nested fields by including, excluding, or reshaping fields.'
            ),
        }),
      ])
    );
  return z.intersection(
    z.object({
      _id: z
        .string()
        .describe('Job ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      startedAt: z
        .date()
        .describe('When the job was submitted.')
        .optional()
        .nullable(),
      status: z
        .enum([
          'UNINITIALIZED',
          'INITIALIZING',
          'IN_PROGRESS',
          'COMPLETED',
          'FAILED',
          'PARTIALLY_SUCCESSFUL',
        ])
        .describe('Current job status.')
        .optional(),
      source: z
        .intersection(
          z.object({}),
          z.xor([
            z.object({
              wixDataCollection: z.never().optional(),
              localization: z.never().optional(),
              file: z.never().optional(),
            }),
            z.object({
              localization: z.never().optional(),
              file: z.never().optional(),
              wixDataCollection: z
                .intersection(
                  z.object({
                    collectionId: z
                      .string()
                      .describe('ID of the data collection.')
                      .min(1)
                      .max(256)
                      .optional(),
                    filter: z
                      .record(z.string(), z.any())
                      .describe(
                        'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).\nDeprecated: Use `filter_query.filter` instead.'
                      )
                      .optional()
                      .nullable(),
                    fields: z.array(z.string()).optional(),
                  }),
                  z.xor([
                    z.object({
                      filterQuery: z.never().optional(),
                      aggregationQuery: z.never().optional(),
                    }),
                    z.object({
                      aggregationQuery: z.never().optional(),
                      filterQuery: z
                        .object({
                          filter: z
                            .record(z.string(), z.any())
                            .describe(
                              'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).'
                            )
                            .optional()
                            .nullable(),
                          fields: z.array(z.string()).optional(),
                        })
                        .describe(
                          'Filter and field selection to apply to the collection items.'
                        ),
                    }),
                    z.object({
                      filterQuery: z.never().optional(),
                      aggregationQuery: z
                        .object({
                          aggregationPipeline: z
                            .intersection(
                              z.object({
                                stages: z
                                  .array(
                                    z.intersection(
                                      z.object({}),
                                      z.xor([
                                        z.object({
                                          group: z.never().optional(),
                                          filter: z.never().optional(),
                                          sort: z.never().optional(),
                                          projection: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z.never().optional(),
                                        }),
                                        z.object({
                                          filter: z.never().optional(),
                                          sort: z.never().optional(),
                                          projection: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z.never().optional(),
                                          group: z
                                            .object({
                                              groupIds: z
                                                .array(
                                                  z.object({
                                                    key: z
                                                      .string()
                                                      .describe(
                                                        "Name of the field to group items by.\n\nThis becomes the field name in the result's `_id` property."
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                    expression:
                                                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                        .describe(
                                                          "Expression to determine the grouping value. Items whose expression resolves to the same value are grouped together in the result item's `_id` property."
                                                        )
                                                        .optional(),
                                                  })
                                                )
                                                .max(1000)
                                                .optional(),
                                              accumulators: z
                                                .array(
                                                  z.intersection(
                                                    z.object({
                                                      resultFieldName: z
                                                        .string()
                                                        .describe(
                                                          'Field key in the output item to store the result in.'
                                                        )
                                                        .max(1000)
                                                        .optional(),
                                                    }),
                                                    z.xor([
                                                      z.object({
                                                        avg: z
                                                          .never()
                                                          .optional(),
                                                        min: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .never()
                                                          .optional(),
                                                      }),
                                                      z.object({
                                                        min: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .never()
                                                          .optional(),
                                                        avg: z
                                                          .object({
                                                            expression:
                                                              comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                .describe(
                                                                  "Expression to calculate the group's average value.\n\nExpression must resolve to a number."
                                                                )
                                                                .optional(),
                                                          })
                                                          .describe(
                                                            'Calculates the average value across all items in the group based on the specified expression.'
                                                          ),
                                                      }),
                                                      z.object({
                                                        avg: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .never()
                                                          .optional(),
                                                        min: z
                                                          .object({
                                                            expression:
                                                              comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                .describe(
                                                                  "Expression to find the group's minimum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                )
                                                                .optional(),
                                                          })
                                                          .describe(
                                                            'Finds the minimum value across all items in the group.'
                                                          ),
                                                      }),
                                                      z.object({
                                                        avg: z
                                                          .never()
                                                          .optional(),
                                                        min: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .object({
                                                            expression:
                                                              comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                .describe(
                                                                  "Expression to find the group's maximum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                )
                                                                .optional(),
                                                          })
                                                          .describe(
                                                            'Finds the maximum value across all items in the group.'
                                                          ),
                                                      }),
                                                      z.object({
                                                        avg: z
                                                          .never()
                                                          .optional(),
                                                        min: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .object({
                                                            expression:
                                                              comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                .describe(
                                                                  "Expression to calculate the group's total sum.\n\nExpression must resolve to a number."
                                                                )
                                                                .optional(),
                                                          })
                                                          .describe(
                                                            'Calculates the sum of the specified expression across all items in the group.'
                                                          ),
                                                      }),
                                                      z.object({
                                                        avg: z
                                                          .never()
                                                          .optional(),
                                                        min: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .object({
                                                            expression:
                                                              comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                .describe(
                                                                  'Expression to find the first item in the group.'
                                                                )
                                                                .optional(),
                                                          })
                                                          .describe(
                                                            'Finds the first item in the group.'
                                                          ),
                                                      }),
                                                      z.object({
                                                        avg: z
                                                          .never()
                                                          .optional(),
                                                        min: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .object({
                                                            expression:
                                                              comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                .describe(
                                                                  'Expression to find the last item in the group.'
                                                                )
                                                                .optional(),
                                                          })
                                                          .describe(
                                                            'Finds the last item in the group.'
                                                          ),
                                                      }),
                                                      z.object({
                                                        avg: z
                                                          .never()
                                                          .optional(),
                                                        min: z
                                                          .never()
                                                          .optional(),
                                                        max: z
                                                          .never()
                                                          .optional(),
                                                        sum: z
                                                          .never()
                                                          .optional(),
                                                        first: z
                                                          .never()
                                                          .optional(),
                                                        last: z
                                                          .never()
                                                          .optional(),
                                                        push: z
                                                          .object({
                                                            expression:
                                                              comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                .describe(
                                                                  'Expression to collect items into an array.'
                                                                )
                                                                .optional(),
                                                          })
                                                          .describe(
                                                            'Collects values from all items in the group into an array.'
                                                          ),
                                                      }),
                                                    ])
                                                  )
                                                )
                                                .max(1000)
                                                .optional(),
                                            })
                                            .describe(
                                              'Groups aggregated items to new result items.'
                                            ),
                                        }),
                                        z.object({
                                          group: z.never().optional(),
                                          sort: z.never().optional(),
                                          projection: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z.never().optional(),
                                          filter: z
                                            .record(z.string(), z.any())
                                            .describe(
                                              'Aggregation filter. Only items that match the filter are processed.\n\nLearn more about [filters in API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).\n\n> **Note:** The values you provide for each filter field must adhere to that field\'s data type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).'
                                            ),
                                        }),
                                        z.object({
                                          group: z.never().optional(),
                                          filter: z.never().optional(),
                                          projection: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z.never().optional(),
                                          sort: z
                                            .object({
                                              values: z
                                                .array(
                                                  z.object({
                                                    fieldName: z
                                                      .string()
                                                      .describe(
                                                        'Name of the field to sort by.'
                                                      )
                                                      .min(1)
                                                      .max(1000)
                                                      .optional(),
                                                    order: z
                                                      .enum(['ASC', 'DESC'])
                                                      .describe('Sort order.')
                                                      .optional(),
                                                  })
                                                )
                                                .max(1000)
                                                .optional(),
                                            })
                                            .describe(
                                              'Sorting preferences.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                            ),
                                        }),
                                        z.object({
                                          group: z.never().optional(),
                                          filter: z.never().optional(),
                                          sort: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z.never().optional(),
                                          projection: z
                                            .object({
                                              fields: z
                                                .array(
                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                                                )
                                                .max(1000)
                                                .optional(),
                                            })
                                            .describe(
                                              'Transforms items by including, excluding, or reshaping fields.'
                                            ),
                                        }),
                                        z.object({
                                          group: z.never().optional(),
                                          filter: z.never().optional(),
                                          sort: z.never().optional(),
                                          projection: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z.never().optional(),
                                          objectToArray: z
                                            .object({
                                              objectFieldName: z
                                                .string()
                                                .describe(
                                                  'Key of the object field to convert to an array.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                )
                                                .max(1000)
                                                .optional(),
                                              destinationFieldName: z
                                                .string()
                                                .describe(
                                                  'Key of the new array to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                )
                                                .max(1000)
                                                .optional(),
                                            })
                                            .describe(
                                              "Transforms an object into an array where each object property becomes a new array element containing the property's key and value, as well as all other properties from the original object."
                                            ),
                                        }),
                                        z.object({
                                          group: z.never().optional(),
                                          filter: z.never().optional(),
                                          sort: z.never().optional(),
                                          projection: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z.never().optional(),
                                          unwindArray: z
                                            .object({
                                              arrayFieldName: z
                                                .string()
                                                .describe(
                                                  'Key of the array field to unwind.\n\nUse dot notation to specify a nested array. For example, `user.products` or `product.colors`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                )
                                                .max(1000)
                                                .optional(),
                                            })
                                            .describe(
                                              'Creates a result item for each array element. Each result contains the full original item, with the array field replaced by an element whose key is the array name and whose value is the array element.'
                                            ),
                                        }),
                                        z.object({
                                          group: z.never().optional(),
                                          filter: z.never().optional(),
                                          sort: z.never().optional(),
                                          projection: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          limit: z.never().optional(),
                                          skip: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Number of results to skip from the beginning of the result set.'
                                            ),
                                        }),
                                        z.object({
                                          group: z.never().optional(),
                                          filter: z.never().optional(),
                                          sort: z.never().optional(),
                                          projection: z.never().optional(),
                                          objectToArray: z.never().optional(),
                                          unwindArray: z.never().optional(),
                                          skip: z.never().optional(),
                                          limit: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Maximum number of results to return.'
                                            ),
                                        }),
                                      ])
                                    )
                                  )
                                  .max(100)
                                  .optional(),
                              }),
                              z.xor([
                                z.object({
                                  paging: z.never().optional(),
                                  cursorPaging: z.never().optional(),
                                }),
                                z.object({
                                  cursorPaging: z.never().optional(),
                                  paging: z
                                    .object({
                                      limit: z
                                        .number()
                                        .int()
                                        .describe('Number of items to load.')
                                        .min(0)
                                        .optional()
                                        .nullable(),
                                      offset: z
                                        .number()
                                        .int()
                                        .describe(
                                          'Number of items to skip in the current sort order.'
                                        )
                                        .min(0)
                                        .optional()
                                        .nullable(),
                                    })
                                    .describe(
                                      'Paging options to limit and skip the number of results.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                    ),
                                }),
                                z.object({
                                  paging: z.never().optional(),
                                  cursorPaging: z
                                    .object({
                                      limit: z
                                        .number()
                                        .int()
                                        .describe('Number of items to load.')
                                        .min(0)
                                        .max(1000)
                                        .optional()
                                        .nullable(),
                                      cursor: z
                                        .string()
                                        .describe(
                                          "Pointer to the next or previous page in the list of results.\n\nYou can get the relevant cursor token\nfrom the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                                        )
                                        .max(150000)
                                        .optional()
                                        .nullable(),
                                    })
                                    .describe(
                                      'Cursor token referring to a page of results.\n\nNot used in the first request. Subsequent requests use the cursor token and not `filter` or `sort`.'
                                    ),
                                }),
                              ])
                            )
                            .describe(
                              'Aggregation pipeline to run on the collection.'
                            )
                            .optional(),
                          fields: z
                            .array(
                              z.object({
                                key: z
                                  .string()
                                  .describe(
                                    'Field ID.\n\nIf the field type is `Array`, specify the item index. If the field type is `Object`, specify the field path. Use dot notation to specify nested fields, for example: `data.address.city`.'
                                  )
                                  .max(1024)
                                  .optional(),
                                displayName: z
                                  .string()
                                  .describe(
                                    'Field display name.\n\nWhen moving items to CSV files, use this to set the header of the target column.'
                                  )
                                  .max(1024)
                                  .optional(),
                                fieldType: z
                                  .enum([
                                    'ANY',
                                    'STRING',
                                    'NUMBER',
                                    'BOOLEAN',
                                    'DATE',
                                    'DATETIME',
                                    'BINARY',
                                    'OBJECT',
                                    'ARRAY',
                                    'URL',
                                    'WIX_MEDIA_URL',
                                    'WIX_MEDIA_IMAGE_URL',
                                    'WIX_MEDIA_VIDEO_URL',
                                    'WIX_MEDIA_DOCUMENT_URL',
                                    'IMAGE_URL',
                                    'VIDEO_URL',
                                  ])
                                  .describe(
                                    'Field data type. Default: `ANY`.\n\nLearn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).'
                                  )
                                  .optional(),
                              })
                            )
                            .min(0)
                            .max(1000)
                            .optional(),
                        })
                        .describe(
                          'Aggregation pipeline to run on the collection.'
                        ),
                    }),
                  ])
                )
                .describe(
                  'Wix data collection.\n\nYou can move items from native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                ),
            }),
            z.object({
              wixDataCollection: z.never().optional(),
              file: z.never().optional(),
              localization: z
                .object({
                  languages: z.array(z.string()).min(2).max(64).optional(),
                })
                .describe(
                  'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                ),
            }),
            z.object({
              wixDataCollection: z.never().optional(),
              localization: z.never().optional(),
              file: z
                .object({
                  format: z
                    .enum(['UNKNOWN', 'CSV', 'JSONL'])
                    .describe(
                      'File format. If not specified, automatically determined by Wix.'
                    )
                    .optional(),
                  fileId: z
                    .string()
                    .describe(
                      "File ID as returned in the `fileId` property of the Create File Upload URL method's response."
                    )
                    .max(512)
                    .optional(),
                  url: z
                    .string()
                    .describe(
                      'URL where the source file is uploaded. Automatically generated by Wix.'
                    )
                    .max(2048)
                    .optional(),
                })
                .describe(
                  'Source file.\n\nYou can import data from files in CSV or JSONL formats. Uploading a file with an invalid format causes the movement job to fail.\n\nTo upload a file, call Create File Upload Url ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/movement-jobs/create-file-upload-url) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-movement-jobs/create-file-upload-url)) and use the `uploadUrl` from the response. For example:\n\n`curl --request PUT --upload-file "${path_to_file}" "${uploadUrl}"`'
                ),
            }),
          ])
        )
        .describe('Source to move data from.')
        .optional(),
      destination: z
        .intersection(
          z.object({}),
          z.xor([
            z.object({
              wixDataCollection: z.never().optional(),
              localization: z.never().optional(),
              file: z.never().optional(),
            }),
            z.object({
              localization: z.never().optional(),
              file: z.never().optional(),
              wixDataCollection: z
                .object({
                  collectionId: z
                    .string()
                    .describe('ID of the destination collection.')
                    .max(256)
                    .optional(),
                  writePolicy: z
                    .enum(['OVERWRITE', 'SKIP_EXISTING', 'TRUNCATE_BEFORE'])
                    .describe(
                      'When items already exist in the destination collection, the data writing policy.\n\nDefault: `OVERWRITE`.'
                    )
                    .optional(),
                })
                .describe(
                  'Wix data collection.\n\nYou can move items to native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                ),
            }),
            z.object({
              wixDataCollection: z.never().optional(),
              file: z.never().optional(),
              localization: z
                .object({
                  languages: z.array(z.string()).min(2).max(64).optional(),
                })
                .describe(
                  'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                ),
            }),
            z.object({
              wixDataCollection: z.never().optional(),
              localization: z.never().optional(),
              file: z
                .object({
                  format: z
                    .enum(['UNKNOWN', 'CSV', 'JSONL'])
                    .describe('File format.')
                    .optional(),
                  fileName: z
                    .string()
                    .describe('File name.')
                    .max(512)
                    .optional()
                    .nullable(),
                  url: z
                    .string()
                    .describe('File download URL.')
                    .max(2048)
                    .optional(),
                })
                .describe('Downloadable file with the moved items.'),
            }),
          ])
        )
        .describe('Destination to move data to.')
        .optional(),
      name: z.string().describe('Job name.').max(1024).optional(),
      progress: z
        .object({
          current: z
            .number()
            .int()
            .describe('Number of units already processed.')
            .optional(),
          total: z
            .number()
            .int()
            .describe('Total number of units to move.')
            .optional()
            .nullable(),
          itemsRejected: z
            .number()
            .int()
            .describe('Number of items that failed to move to the destination.')
            .optional(),
          itemsSuccessful: z
            .number()
            .int()
            .describe('Number of items successfully moved to the destination.')
            .optional(),
        })
        .describe(
          'When the job `status` is `IN_PROGRESS`, the progress details.'
        )
        .optional(),
      finishedAt: z
        .date()
        .describe(
          'Job finish time.\n\nA job is considered finished when its `status` updates to `COMPLETED`, `FAILED`, or `PARTIALLY_SUCCESSFUL`.'
        )
        .optional()
        .nullable(),
      error: z
        .object({
          code: z.string().describe('Error code.').optional(),
          description: z
            .string()
            .describe('Description of the error.')
            .optional(),
          data: z
            .record(z.string(), z.any())
            .describe('Data related to the error.')
            .optional()
            .nullable(),
        })
        .describe('Error information.')
        .optional(),
      sourceSiteId: z
        .string()
        .describe(
          'When moving data from a Wix data collection, the source site ID.\n\nBy default, the source site is the current site. To move data from [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      destinationSiteId: z
        .string()
        .describe(
          'When moving data to a Wix data collection, the destination site ID.\n\nBy default, the destination site is the current site. To move data to [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      logsRecorded: z
        .number()
        .int()
        .describe('Number of recorded logs.')
        .optional(),
      scheduleId: z
        .string()
        .describe(
          'Sync Schedule ID, if the job was triggered by a sync schedule.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe('Extended fields for custom metadata added by applications.')
        .optional(),
      workflowId: z
        .string()
        .describe(
          'Workflow ID, if the job was created as a child step of a workflow.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
    }),
    z.xor([
      z.object({ partiallySuccessfulOptions: z.never().optional() }),
      z.object({
        partiallySuccessfulOptions: z
          .object({
            cause: z
              .string()
              .describe('Reason the job was partially successful.')
              .max(1000)
              .optional(),
          })
          .describe(
            "When the job's `status` is `PARTIALLY_SUCCESSFUL`, the additional details."
          ),
      }),
    ])
  );
})();
export const ListJobsRequest = z.object({
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe('Maximum number of items to return in the results.')
            .min(0)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe(
              "Pointer to the next or previous page in the list of results.\n\nPass the relevant cursor token from the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe('Paging metadata.')
        .optional(),
    })
    .optional(),
});
export const ListJobsResponse = (() => {
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
        }),
        z.object({
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          fieldPath: z
            .string()
            .describe(
              'Path to the field containing the value to resolve.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`.'
            )
            .max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          text: z.string().describe('Text value.').max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          numeric: z.number().describe('Number value.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          add: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Adds the specified expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          sum: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Calculates the total sum of multiple expressions.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          subtract: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract `secondExpression` from.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract from `firstExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Subtracts 1 expression from another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          multiply: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Multiplies multiple expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          divide: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe('Divides 1 expression by another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          abs: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to find the absolute value of.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Finds the absolute value of an expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          mod: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression` to find the remainder.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe(
              'Finds the remainder when dividing 1 expression by another.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          floor: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round down to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression down to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          ceil: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round up to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression up to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          concat: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Joins multiple expressions together to create a string.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          stringify: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe('Expression to convert to a string.')
                .optional(),
            })
            .describe('Converts an expression to a string.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toLower: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to lowercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to lowercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toUpper: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to uppercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to uppercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          length: z.never().optional(),
          substring: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to extract a substring from.\n\nExpression must resolve to a string.'
                )
                .optional(),
              startExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Starting position of the substring to extract, specified in zero-based indexing.\n\nExpression must resolve to a number.'
                )
                .optional(),
              lengthExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Number of characters to extract from the starting position.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Extracts a portion of a string expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to count the total number of characters of.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Finds the length of a string expression.'),
        }),
      ])
    );
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
        }),
        z.object({
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          include: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to include in the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, includes only the specified field in the result. All other fields are excluded.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          exclude: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to exclude from the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, excludes the specified field from the result. All other fields are included.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          projectNested: z.never().optional(),
          reshape: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the field to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              expression:
                comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  .describe(
                    'Expression to resolve. The result of the expression becomes the value of the new field.'
                  )
                  .optional(),
            })
            .describe(
              'Reshapes a new field based on the specified expression. The field used by the expression is not included in the result.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the parent field for the nested fields.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              fields: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Creates nested fields by including, excluding, or reshaping fields.'
            ),
        }),
      ])
    );
  return z.object({
    jobs: z
      .array(
        z.intersection(
          z.object({
            _id: z
              .string()
              .describe('Job ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            startedAt: z
              .date()
              .describe('When the job was submitted.')
              .optional()
              .nullable(),
            status: z
              .enum([
                'UNINITIALIZED',
                'INITIALIZING',
                'IN_PROGRESS',
                'COMPLETED',
                'FAILED',
                'PARTIALLY_SUCCESSFUL',
              ])
              .describe('Current job status.')
              .optional(),
            source: z
              .intersection(
                z.object({}),
                z.xor([
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z.never().optional(),
                  }),
                  z.object({
                    localization: z.never().optional(),
                    file: z.never().optional(),
                    wixDataCollection: z
                      .intersection(
                        z.object({
                          collectionId: z
                            .string()
                            .describe('ID of the data collection.')
                            .min(1)
                            .max(256)
                            .optional(),
                          filter: z
                            .record(z.string(), z.any())
                            .describe(
                              'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).\nDeprecated: Use `filter_query.filter` instead.'
                            )
                            .optional()
                            .nullable(),
                          fields: z.array(z.string()).optional(),
                        }),
                        z.xor([
                          z.object({
                            filterQuery: z.never().optional(),
                            aggregationQuery: z.never().optional(),
                          }),
                          z.object({
                            aggregationQuery: z.never().optional(),
                            filterQuery: z
                              .object({
                                filter: z
                                  .record(z.string(), z.any())
                                  .describe(
                                    'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).'
                                  )
                                  .optional()
                                  .nullable(),
                                fields: z.array(z.string()).optional(),
                              })
                              .describe(
                                'Filter and field selection to apply to the collection items.'
                              ),
                          }),
                          z.object({
                            filterQuery: z.never().optional(),
                            aggregationQuery: z
                              .object({
                                aggregationPipeline: z
                                  .intersection(
                                    z.object({
                                      stages: z
                                        .array(
                                          z.intersection(
                                            z.object({}),
                                            z.xor([
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                              }),
                                              z.object({
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                group: z
                                                  .object({
                                                    groupIds: z
                                                      .array(
                                                        z.object({
                                                          key: z
                                                            .string()
                                                            .describe(
                                                              "Name of the field to group items by.\n\nThis becomes the field name in the result's `_id` property."
                                                            )
                                                            .max(1000)
                                                            .optional(),
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                "Expression to determine the grouping value. Items whose expression resolves to the same value are grouped together in the result item's `_id` property."
                                                              )
                                                              .optional(),
                                                        })
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                    accumulators: z
                                                      .array(
                                                        z.intersection(
                                                          z.object({
                                                            resultFieldName: z
                                                              .string()
                                                              .describe(
                                                                'Field key in the output item to store the result in.'
                                                              )
                                                              .max(1000)
                                                              .optional(),
                                                          }),
                                                          z.xor([
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                            }),
                                                            z.object({
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              avg: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to calculate the group's average value.\n\nExpression must resolve to a number."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Calculates the average value across all items in the group based on the specified expression.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to find the group's minimum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the minimum value across all items in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to find the group's maximum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the maximum value across all items in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to calculate the group's total sum.\n\nExpression must resolve to a number."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Calculates the sum of the specified expression across all items in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        'Expression to find the first item in the group.'
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the first item in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        'Expression to find the last item in the group.'
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the last item in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        'Expression to collect items into an array.'
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Collects values from all items in the group into an array.'
                                                                ),
                                                            }),
                                                          ])
                                                        )
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Groups aggregated items to new result items.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                filter: z
                                                  .record(z.string(), z.any())
                                                  .describe(
                                                    'Aggregation filter. Only items that match the filter are processed.\n\nLearn more about [filters in API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).\n\n> **Note:** The values you provide for each filter field must adhere to that field\'s data type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                sort: z
                                                  .object({
                                                    values: z
                                                      .array(
                                                        z.object({
                                                          fieldName: z
                                                            .string()
                                                            .describe(
                                                              'Name of the field to sort by.'
                                                            )
                                                            .min(1)
                                                            .max(1000)
                                                            .optional(),
                                                          order: z
                                                            .enum([
                                                              'ASC',
                                                              'DESC',
                                                            ])
                                                            .describe(
                                                              'Sort order.'
                                                            )
                                                            .optional(),
                                                        })
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Sorting preferences.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                projection: z
                                                  .object({
                                                    fields: z
                                                      .array(
                                                        comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Transforms items by including, excluding, or reshaping fields.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                objectToArray: z
                                                  .object({
                                                    objectFieldName: z
                                                      .string()
                                                      .describe(
                                                        'Key of the object field to convert to an array.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                    destinationFieldName: z
                                                      .string()
                                                      .describe(
                                                        'Key of the new array to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    "Transforms an object into an array where each object property becomes a new array element containing the property's key and value, as well as all other properties from the original object."
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                unwindArray: z
                                                  .object({
                                                    arrayFieldName: z
                                                      .string()
                                                      .describe(
                                                        'Key of the array field to unwind.\n\nUse dot notation to specify a nested array. For example, `user.products` or `product.colors`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Creates a result item for each array element. Each result contains the full original item, with the array field replaced by an element whose key is the array name and whose value is the array element.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                limit: z.never().optional(),
                                                skip: z
                                                  .number()
                                                  .int()
                                                  .describe(
                                                    'Number of results to skip from the beginning of the result set.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z
                                                  .number()
                                                  .int()
                                                  .describe(
                                                    'Maximum number of results to return.'
                                                  ),
                                              }),
                                            ])
                                          )
                                        )
                                        .max(100)
                                        .optional(),
                                    }),
                                    z.xor([
                                      z.object({
                                        paging: z.never().optional(),
                                        cursorPaging: z.never().optional(),
                                      }),
                                      z.object({
                                        cursorPaging: z.never().optional(),
                                        paging: z
                                          .object({
                                            limit: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Number of items to load.'
                                              )
                                              .min(0)
                                              .optional()
                                              .nullable(),
                                            offset: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Number of items to skip in the current sort order.'
                                              )
                                              .min(0)
                                              .optional()
                                              .nullable(),
                                          })
                                          .describe(
                                            'Paging options to limit and skip the number of results.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                          ),
                                      }),
                                      z.object({
                                        paging: z.never().optional(),
                                        cursorPaging: z
                                          .object({
                                            limit: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Number of items to load.'
                                              )
                                              .min(0)
                                              .max(1000)
                                              .optional()
                                              .nullable(),
                                            cursor: z
                                              .string()
                                              .describe(
                                                "Pointer to the next or previous page in the list of results.\n\nYou can get the relevant cursor token\nfrom the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                                              )
                                              .max(150000)
                                              .optional()
                                              .nullable(),
                                          })
                                          .describe(
                                            'Cursor token referring to a page of results.\n\nNot used in the first request. Subsequent requests use the cursor token and not `filter` or `sort`.'
                                          ),
                                      }),
                                    ])
                                  )
                                  .describe(
                                    'Aggregation pipeline to run on the collection.'
                                  )
                                  .optional(),
                                fields: z
                                  .array(
                                    z.object({
                                      key: z
                                        .string()
                                        .describe(
                                          'Field ID.\n\nIf the field type is `Array`, specify the item index. If the field type is `Object`, specify the field path. Use dot notation to specify nested fields, for example: `data.address.city`.'
                                        )
                                        .max(1024)
                                        .optional(),
                                      displayName: z
                                        .string()
                                        .describe(
                                          'Field display name.\n\nWhen moving items to CSV files, use this to set the header of the target column.'
                                        )
                                        .max(1024)
                                        .optional(),
                                      fieldType: z
                                        .enum([
                                          'ANY',
                                          'STRING',
                                          'NUMBER',
                                          'BOOLEAN',
                                          'DATE',
                                          'DATETIME',
                                          'BINARY',
                                          'OBJECT',
                                          'ARRAY',
                                          'URL',
                                          'WIX_MEDIA_URL',
                                          'WIX_MEDIA_IMAGE_URL',
                                          'WIX_MEDIA_VIDEO_URL',
                                          'WIX_MEDIA_DOCUMENT_URL',
                                          'IMAGE_URL',
                                          'VIDEO_URL',
                                        ])
                                        .describe(
                                          'Field data type. Default: `ANY`.\n\nLearn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).'
                                        )
                                        .optional(),
                                    })
                                  )
                                  .min(0)
                                  .max(1000)
                                  .optional(),
                              })
                              .describe(
                                'Aggregation pipeline to run on the collection.'
                              ),
                          }),
                        ])
                      )
                      .describe(
                        'Wix data collection.\n\nYou can move items from native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    file: z.never().optional(),
                    localization: z
                      .object({
                        languages: z
                          .array(z.string())
                          .min(2)
                          .max(64)
                          .optional(),
                      })
                      .describe(
                        'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z
                      .object({
                        format: z
                          .enum(['UNKNOWN', 'CSV', 'JSONL'])
                          .describe(
                            'File format. If not specified, automatically determined by Wix.'
                          )
                          .optional(),
                        fileId: z
                          .string()
                          .describe(
                            "File ID as returned in the `fileId` property of the Create File Upload URL method's response."
                          )
                          .max(512)
                          .optional(),
                        url: z
                          .string()
                          .describe(
                            'URL where the source file is uploaded. Automatically generated by Wix.'
                          )
                          .max(2048)
                          .optional(),
                      })
                      .describe(
                        'Source file.\n\nYou can import data from files in CSV or JSONL formats. Uploading a file with an invalid format causes the movement job to fail.\n\nTo upload a file, call Create File Upload Url ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/movement-jobs/create-file-upload-url) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-movement-jobs/create-file-upload-url)) and use the `uploadUrl` from the response. For example:\n\n`curl --request PUT --upload-file "${path_to_file}" "${uploadUrl}"`'
                      ),
                  }),
                ])
              )
              .describe('Source to move data from.')
              .optional(),
            destination: z
              .intersection(
                z.object({}),
                z.xor([
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z.never().optional(),
                  }),
                  z.object({
                    localization: z.never().optional(),
                    file: z.never().optional(),
                    wixDataCollection: z
                      .object({
                        collectionId: z
                          .string()
                          .describe('ID of the destination collection.')
                          .max(256)
                          .optional(),
                        writePolicy: z
                          .enum([
                            'OVERWRITE',
                            'SKIP_EXISTING',
                            'TRUNCATE_BEFORE',
                          ])
                          .describe(
                            'When items already exist in the destination collection, the data writing policy.\n\nDefault: `OVERWRITE`.'
                          )
                          .optional(),
                      })
                      .describe(
                        'Wix data collection.\n\nYou can move items to native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    file: z.never().optional(),
                    localization: z
                      .object({
                        languages: z
                          .array(z.string())
                          .min(2)
                          .max(64)
                          .optional(),
                      })
                      .describe(
                        'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z
                      .object({
                        format: z
                          .enum(['UNKNOWN', 'CSV', 'JSONL'])
                          .describe('File format.')
                          .optional(),
                        fileName: z
                          .string()
                          .describe('File name.')
                          .max(512)
                          .optional()
                          .nullable(),
                        url: z
                          .string()
                          .describe('File download URL.')
                          .max(2048)
                          .optional(),
                      })
                      .describe('Downloadable file with the moved items.'),
                  }),
                ])
              )
              .describe('Destination to move data to.')
              .optional(),
            name: z.string().describe('Job name.').max(1024).optional(),
            progress: z
              .object({
                current: z
                  .number()
                  .int()
                  .describe('Number of units already processed.')
                  .optional(),
                total: z
                  .number()
                  .int()
                  .describe('Total number of units to move.')
                  .optional()
                  .nullable(),
                itemsRejected: z
                  .number()
                  .int()
                  .describe(
                    'Number of items that failed to move to the destination.'
                  )
                  .optional(),
                itemsSuccessful: z
                  .number()
                  .int()
                  .describe(
                    'Number of items successfully moved to the destination.'
                  )
                  .optional(),
              })
              .describe(
                'When the job `status` is `IN_PROGRESS`, the progress details.'
              )
              .optional(),
            finishedAt: z
              .date()
              .describe(
                'Job finish time.\n\nA job is considered finished when its `status` updates to `COMPLETED`, `FAILED`, or `PARTIALLY_SUCCESSFUL`.'
              )
              .optional()
              .nullable(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Error information.')
              .optional(),
            sourceSiteId: z
              .string()
              .describe(
                'When moving data from a Wix data collection, the source site ID.\n\nBy default, the source site is the current site. To move data from [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            destinationSiteId: z
              .string()
              .describe(
                'When moving data to a Wix data collection, the destination site ID.\n\nBy default, the destination site is the current site. To move data to [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            logsRecorded: z
              .number()
              .int()
              .describe('Number of recorded logs.')
              .optional(),
            scheduleId: z
              .string()
              .describe(
                'Sync Schedule ID, if the job was triggered by a sync schedule.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            extendedFields: z
              .object({
                namespaces: z
                  .record(z.string(), z.record(z.string(), z.any()))
                  .describe(
                    'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
                  )
                  .optional(),
              })
              .describe(
                'Extended fields for custom metadata added by applications.'
              )
              .optional(),
            workflowId: z
              .string()
              .describe(
                'Workflow ID, if the job was created as a child step of a workflow.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
          }),
          z.xor([
            z.object({ partiallySuccessfulOptions: z.never().optional() }),
            z.object({
              partiallySuccessfulOptions: z
                .object({
                  cause: z
                    .string()
                    .describe('Reason the job was partially successful.')
                    .max(1000)
                    .optional(),
                })
                .describe(
                  "When the job's `status` is `PARTIALLY_SUCCESSFUL`, the additional details."
                ),
            }),
          ])
        )
      )
      .optional(),
    pagingMetadata: z
      .object({
        count: z
          .number()
          .int()
          .describe('Number of items returned in current page.')
          .optional()
          .nullable(),
        cursors: z
          .object({
            next: z
              .string()
              .describe(
                'Cursor string pointing to the next page in the list of results.'
              )
              .max(16000)
              .optional()
              .nullable(),
            prev: z
              .string()
              .describe(
                'Cursor pointing to the previous page in the list of results.'
              )
              .max(16000)
              .optional()
              .nullable(),
          })
          .describe(
            'Cursor strings that point to the next page, previous page, or both.'
          )
          .optional(),
        hasNext: z
          .boolean()
          .describe(
            'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
          )
          .optional()
          .nullable(),
      })
      .describe('Paging metadata.')
      .optional(),
  });
})();
export const QueryJobsRequest = z.object({
  query: z
    .intersection(
      z.object({
        filter: z
          .record(z.string(), z.any())
          .describe(
            'Filter object.\n\nLearn more about [filtering](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).'
          )
          .optional()
          .nullable(),
        sort: z
          .array(
            z.object({
              fieldName: z
                .string()
                .describe('Name of the field to sort by.')
                .max(512)
                .optional(),
              order: z.enum(['ASC', 'DESC']).optional(),
            })
          )
          .max(5)
          .optional(),
      }),
      z.xor([
        z.object({ cursorPaging: z.never().optional() }),
        z.object({
          cursorPaging: z
            .object({
              limit: z
                .number()
                .int()
                .describe('Maximum number of items to return in the results.')
                .min(0)
                .max(100)
                .optional()
                .nullable(),
              cursor: z
                .string()
                .describe(
                  "Pointer to the next or previous page in the list of results.\n\nPass the relevant cursor token from the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                )
                .max(16000)
                .optional()
                .nullable(),
            })
            .describe(
              'Cursor paging options.\n\nLearn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).'
            ),
        }),
      ])
    )
    .describe(
      'Query preferences. Learn more about [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).'
    ),
});
export const QueryJobsResponse = (() => {
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
        }),
        z.object({
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          fieldPath: z
            .string()
            .describe(
              'Path to the field containing the value to resolve.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`.'
            )
            .max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          text: z.string().describe('Text value.').max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          numeric: z.number().describe('Number value.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          add: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Adds the specified expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          sum: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Calculates the total sum of multiple expressions.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          subtract: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract `secondExpression` from.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract from `firstExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Subtracts 1 expression from another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          multiply: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Multiplies multiple expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          divide: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe('Divides 1 expression by another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          abs: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to find the absolute value of.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Finds the absolute value of an expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          mod: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression` to find the remainder.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe(
              'Finds the remainder when dividing 1 expression by another.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          floor: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round down to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression down to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          ceil: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round up to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression up to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          concat: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Joins multiple expressions together to create a string.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          stringify: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe('Expression to convert to a string.')
                .optional(),
            })
            .describe('Converts an expression to a string.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toLower: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to lowercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to lowercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toUpper: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to uppercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to uppercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          length: z.never().optional(),
          substring: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to extract a substring from.\n\nExpression must resolve to a string.'
                )
                .optional(),
              startExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Starting position of the substring to extract, specified in zero-based indexing.\n\nExpression must resolve to a number.'
                )
                .optional(),
              lengthExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Number of characters to extract from the starting position.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Extracts a portion of a string expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to count the total number of characters of.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Finds the length of a string expression.'),
        }),
      ])
    );
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
        }),
        z.object({
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          include: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to include in the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, includes only the specified field in the result. All other fields are excluded.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          exclude: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to exclude from the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, excludes the specified field from the result. All other fields are included.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          projectNested: z.never().optional(),
          reshape: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the field to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              expression:
                comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  .describe(
                    'Expression to resolve. The result of the expression becomes the value of the new field.'
                  )
                  .optional(),
            })
            .describe(
              'Reshapes a new field based on the specified expression. The field used by the expression is not included in the result.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the parent field for the nested fields.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              fields: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Creates nested fields by including, excluding, or reshaping fields.'
            ),
        }),
      ])
    );
  return z.object({
    jobs: z
      .array(
        z.intersection(
          z.object({
            _id: z
              .string()
              .describe('Job ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            startedAt: z
              .date()
              .describe('When the job was submitted.')
              .optional()
              .nullable(),
            status: z
              .enum([
                'UNINITIALIZED',
                'INITIALIZING',
                'IN_PROGRESS',
                'COMPLETED',
                'FAILED',
                'PARTIALLY_SUCCESSFUL',
              ])
              .describe('Current job status.')
              .optional(),
            source: z
              .intersection(
                z.object({}),
                z.xor([
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z.never().optional(),
                  }),
                  z.object({
                    localization: z.never().optional(),
                    file: z.never().optional(),
                    wixDataCollection: z
                      .intersection(
                        z.object({
                          collectionId: z
                            .string()
                            .describe('ID of the data collection.')
                            .min(1)
                            .max(256)
                            .optional(),
                          filter: z
                            .record(z.string(), z.any())
                            .describe(
                              'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).\nDeprecated: Use `filter_query.filter` instead.'
                            )
                            .optional()
                            .nullable(),
                          fields: z.array(z.string()).optional(),
                        }),
                        z.xor([
                          z.object({
                            filterQuery: z.never().optional(),
                            aggregationQuery: z.never().optional(),
                          }),
                          z.object({
                            aggregationQuery: z.never().optional(),
                            filterQuery: z
                              .object({
                                filter: z
                                  .record(z.string(), z.any())
                                  .describe(
                                    'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).'
                                  )
                                  .optional()
                                  .nullable(),
                                fields: z.array(z.string()).optional(),
                              })
                              .describe(
                                'Filter and field selection to apply to the collection items.'
                              ),
                          }),
                          z.object({
                            filterQuery: z.never().optional(),
                            aggregationQuery: z
                              .object({
                                aggregationPipeline: z
                                  .intersection(
                                    z.object({
                                      stages: z
                                        .array(
                                          z.intersection(
                                            z.object({}),
                                            z.xor([
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                              }),
                                              z.object({
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                group: z
                                                  .object({
                                                    groupIds: z
                                                      .array(
                                                        z.object({
                                                          key: z
                                                            .string()
                                                            .describe(
                                                              "Name of the field to group items by.\n\nThis becomes the field name in the result's `_id` property."
                                                            )
                                                            .max(1000)
                                                            .optional(),
                                                          expression:
                                                            comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                              .describe(
                                                                "Expression to determine the grouping value. Items whose expression resolves to the same value are grouped together in the result item's `_id` property."
                                                              )
                                                              .optional(),
                                                        })
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                    accumulators: z
                                                      .array(
                                                        z.intersection(
                                                          z.object({
                                                            resultFieldName: z
                                                              .string()
                                                              .describe(
                                                                'Field key in the output item to store the result in.'
                                                              )
                                                              .max(1000)
                                                              .optional(),
                                                          }),
                                                          z.xor([
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                            }),
                                                            z.object({
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              avg: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to calculate the group's average value.\n\nExpression must resolve to a number."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Calculates the average value across all items in the group based on the specified expression.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to find the group's minimum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the minimum value across all items in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to find the group's maximum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the maximum value across all items in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        "Expression to calculate the group's total sum.\n\nExpression must resolve to a number."
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Calculates the sum of the specified expression across all items in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        'Expression to find the first item in the group.'
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the first item in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        'Expression to find the last item in the group.'
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Finds the last item in the group.'
                                                                ),
                                                            }),
                                                            z.object({
                                                              avg: z
                                                                .never()
                                                                .optional(),
                                                              min: z
                                                                .never()
                                                                .optional(),
                                                              max: z
                                                                .never()
                                                                .optional(),
                                                              sum: z
                                                                .never()
                                                                .optional(),
                                                              first: z
                                                                .never()
                                                                .optional(),
                                                              last: z
                                                                .never()
                                                                .optional(),
                                                              push: z
                                                                .object({
                                                                  expression:
                                                                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                      .describe(
                                                                        'Expression to collect items into an array.'
                                                                      )
                                                                      .optional(),
                                                                })
                                                                .describe(
                                                                  'Collects values from all items in the group into an array.'
                                                                ),
                                                            }),
                                                          ])
                                                        )
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Groups aggregated items to new result items.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                filter: z
                                                  .record(z.string(), z.any())
                                                  .describe(
                                                    'Aggregation filter. Only items that match the filter are processed.\n\nLearn more about [filters in API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).\n\n> **Note:** The values you provide for each filter field must adhere to that field\'s data type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                sort: z
                                                  .object({
                                                    values: z
                                                      .array(
                                                        z.object({
                                                          fieldName: z
                                                            .string()
                                                            .describe(
                                                              'Name of the field to sort by.'
                                                            )
                                                            .min(1)
                                                            .max(1000)
                                                            .optional(),
                                                          order: z
                                                            .enum([
                                                              'ASC',
                                                              'DESC',
                                                            ])
                                                            .describe(
                                                              'Sort order.'
                                                            )
                                                            .optional(),
                                                        })
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Sorting preferences.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                projection: z
                                                  .object({
                                                    fields: z
                                                      .array(
                                                        comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Transforms items by including, excluding, or reshaping fields.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                objectToArray: z
                                                  .object({
                                                    objectFieldName: z
                                                      .string()
                                                      .describe(
                                                        'Key of the object field to convert to an array.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                    destinationFieldName: z
                                                      .string()
                                                      .describe(
                                                        'Key of the new array to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    "Transforms an object into an array where each object property becomes a new array element containing the property's key and value, as well as all other properties from the original object."
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z.never().optional(),
                                                unwindArray: z
                                                  .object({
                                                    arrayFieldName: z
                                                      .string()
                                                      .describe(
                                                        'Key of the array field to unwind.\n\nUse dot notation to specify a nested array. For example, `user.products` or `product.colors`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                      )
                                                      .max(1000)
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    'Creates a result item for each array element. Each result contains the full original item, with the array field replaced by an element whose key is the array name and whose value is the array element.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                limit: z.never().optional(),
                                                skip: z
                                                  .number()
                                                  .int()
                                                  .describe(
                                                    'Number of results to skip from the beginning of the result set.'
                                                  ),
                                              }),
                                              z.object({
                                                group: z.never().optional(),
                                                filter: z.never().optional(),
                                                sort: z.never().optional(),
                                                projection: z
                                                  .never()
                                                  .optional(),
                                                objectToArray: z
                                                  .never()
                                                  .optional(),
                                                unwindArray: z
                                                  .never()
                                                  .optional(),
                                                skip: z.never().optional(),
                                                limit: z
                                                  .number()
                                                  .int()
                                                  .describe(
                                                    'Maximum number of results to return.'
                                                  ),
                                              }),
                                            ])
                                          )
                                        )
                                        .max(100)
                                        .optional(),
                                    }),
                                    z.xor([
                                      z.object({
                                        paging: z.never().optional(),
                                        cursorPaging: z.never().optional(),
                                      }),
                                      z.object({
                                        cursorPaging: z.never().optional(),
                                        paging: z
                                          .object({
                                            limit: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Number of items to load.'
                                              )
                                              .min(0)
                                              .optional()
                                              .nullable(),
                                            offset: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Number of items to skip in the current sort order.'
                                              )
                                              .min(0)
                                              .optional()
                                              .nullable(),
                                          })
                                          .describe(
                                            'Paging options to limit and skip the number of results.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                          ),
                                      }),
                                      z.object({
                                        paging: z.never().optional(),
                                        cursorPaging: z
                                          .object({
                                            limit: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Number of items to load.'
                                              )
                                              .min(0)
                                              .max(1000)
                                              .optional()
                                              .nullable(),
                                            cursor: z
                                              .string()
                                              .describe(
                                                "Pointer to the next or previous page in the list of results.\n\nYou can get the relevant cursor token\nfrom the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                                              )
                                              .max(150000)
                                              .optional()
                                              .nullable(),
                                          })
                                          .describe(
                                            'Cursor token referring to a page of results.\n\nNot used in the first request. Subsequent requests use the cursor token and not `filter` or `sort`.'
                                          ),
                                      }),
                                    ])
                                  )
                                  .describe(
                                    'Aggregation pipeline to run on the collection.'
                                  )
                                  .optional(),
                                fields: z
                                  .array(
                                    z.object({
                                      key: z
                                        .string()
                                        .describe(
                                          'Field ID.\n\nIf the field type is `Array`, specify the item index. If the field type is `Object`, specify the field path. Use dot notation to specify nested fields, for example: `data.address.city`.'
                                        )
                                        .max(1024)
                                        .optional(),
                                      displayName: z
                                        .string()
                                        .describe(
                                          'Field display name.\n\nWhen moving items to CSV files, use this to set the header of the target column.'
                                        )
                                        .max(1024)
                                        .optional(),
                                      fieldType: z
                                        .enum([
                                          'ANY',
                                          'STRING',
                                          'NUMBER',
                                          'BOOLEAN',
                                          'DATE',
                                          'DATETIME',
                                          'BINARY',
                                          'OBJECT',
                                          'ARRAY',
                                          'URL',
                                          'WIX_MEDIA_URL',
                                          'WIX_MEDIA_IMAGE_URL',
                                          'WIX_MEDIA_VIDEO_URL',
                                          'WIX_MEDIA_DOCUMENT_URL',
                                          'IMAGE_URL',
                                          'VIDEO_URL',
                                        ])
                                        .describe(
                                          'Field data type. Default: `ANY`.\n\nLearn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).'
                                        )
                                        .optional(),
                                    })
                                  )
                                  .min(0)
                                  .max(1000)
                                  .optional(),
                              })
                              .describe(
                                'Aggregation pipeline to run on the collection.'
                              ),
                          }),
                        ])
                      )
                      .describe(
                        'Wix data collection.\n\nYou can move items from native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    file: z.never().optional(),
                    localization: z
                      .object({
                        languages: z
                          .array(z.string())
                          .min(2)
                          .max(64)
                          .optional(),
                      })
                      .describe(
                        'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z
                      .object({
                        format: z
                          .enum(['UNKNOWN', 'CSV', 'JSONL'])
                          .describe(
                            'File format. If not specified, automatically determined by Wix.'
                          )
                          .optional(),
                        fileId: z
                          .string()
                          .describe(
                            "File ID as returned in the `fileId` property of the Create File Upload URL method's response."
                          )
                          .max(512)
                          .optional(),
                        url: z
                          .string()
                          .describe(
                            'URL where the source file is uploaded. Automatically generated by Wix.'
                          )
                          .max(2048)
                          .optional(),
                      })
                      .describe(
                        'Source file.\n\nYou can import data from files in CSV or JSONL formats. Uploading a file with an invalid format causes the movement job to fail.\n\nTo upload a file, call Create File Upload Url ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/movement-jobs/create-file-upload-url) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-movement-jobs/create-file-upload-url)) and use the `uploadUrl` from the response. For example:\n\n`curl --request PUT --upload-file "${path_to_file}" "${uploadUrl}"`'
                      ),
                  }),
                ])
              )
              .describe('Source to move data from.')
              .optional(),
            destination: z
              .intersection(
                z.object({}),
                z.xor([
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z.never().optional(),
                  }),
                  z.object({
                    localization: z.never().optional(),
                    file: z.never().optional(),
                    wixDataCollection: z
                      .object({
                        collectionId: z
                          .string()
                          .describe('ID of the destination collection.')
                          .max(256)
                          .optional(),
                        writePolicy: z
                          .enum([
                            'OVERWRITE',
                            'SKIP_EXISTING',
                            'TRUNCATE_BEFORE',
                          ])
                          .describe(
                            'When items already exist in the destination collection, the data writing policy.\n\nDefault: `OVERWRITE`.'
                          )
                          .optional(),
                      })
                      .describe(
                        'Wix data collection.\n\nYou can move items to native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    file: z.never().optional(),
                    localization: z
                      .object({
                        languages: z
                          .array(z.string())
                          .min(2)
                          .max(64)
                          .optional(),
                      })
                      .describe(
                        'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                      ),
                  }),
                  z.object({
                    wixDataCollection: z.never().optional(),
                    localization: z.never().optional(),
                    file: z
                      .object({
                        format: z
                          .enum(['UNKNOWN', 'CSV', 'JSONL'])
                          .describe('File format.')
                          .optional(),
                        fileName: z
                          .string()
                          .describe('File name.')
                          .max(512)
                          .optional()
                          .nullable(),
                        url: z
                          .string()
                          .describe('File download URL.')
                          .max(2048)
                          .optional(),
                      })
                      .describe('Downloadable file with the moved items.'),
                  }),
                ])
              )
              .describe('Destination to move data to.')
              .optional(),
            name: z.string().describe('Job name.').max(1024).optional(),
            progress: z
              .object({
                current: z
                  .number()
                  .int()
                  .describe('Number of units already processed.')
                  .optional(),
                total: z
                  .number()
                  .int()
                  .describe('Total number of units to move.')
                  .optional()
                  .nullable(),
                itemsRejected: z
                  .number()
                  .int()
                  .describe(
                    'Number of items that failed to move to the destination.'
                  )
                  .optional(),
                itemsSuccessful: z
                  .number()
                  .int()
                  .describe(
                    'Number of items successfully moved to the destination.'
                  )
                  .optional(),
              })
              .describe(
                'When the job `status` is `IN_PROGRESS`, the progress details.'
              )
              .optional(),
            finishedAt: z
              .date()
              .describe(
                'Job finish time.\n\nA job is considered finished when its `status` updates to `COMPLETED`, `FAILED`, or `PARTIALLY_SUCCESSFUL`.'
              )
              .optional()
              .nullable(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Error information.')
              .optional(),
            sourceSiteId: z
              .string()
              .describe(
                'When moving data from a Wix data collection, the source site ID.\n\nBy default, the source site is the current site. To move data from [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            destinationSiteId: z
              .string()
              .describe(
                'When moving data to a Wix data collection, the destination site ID.\n\nBy default, the destination site is the current site. To move data to [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            logsRecorded: z
              .number()
              .int()
              .describe('Number of recorded logs.')
              .optional(),
            scheduleId: z
              .string()
              .describe(
                'Sync Schedule ID, if the job was triggered by a sync schedule.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            extendedFields: z
              .object({
                namespaces: z
                  .record(z.string(), z.record(z.string(), z.any()))
                  .describe(
                    'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
                  )
                  .optional(),
              })
              .describe(
                'Extended fields for custom metadata added by applications.'
              )
              .optional(),
            workflowId: z
              .string()
              .describe(
                'Workflow ID, if the job was created as a child step of a workflow.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
          }),
          z.xor([
            z.object({ partiallySuccessfulOptions: z.never().optional() }),
            z.object({
              partiallySuccessfulOptions: z
                .object({
                  cause: z
                    .string()
                    .describe('Reason the job was partially successful.')
                    .max(1000)
                    .optional(),
                })
                .describe(
                  "When the job's `status` is `PARTIALLY_SUCCESSFUL`, the additional details."
                ),
            }),
          ])
        )
      )
      .optional(),
    pagingMetadata: z
      .object({
        count: z
          .number()
          .int()
          .describe('Number of items returned in current page.')
          .optional()
          .nullable(),
        cursors: z
          .object({
            next: z
              .string()
              .describe(
                'Cursor string pointing to the next page in the list of results.'
              )
              .max(16000)
              .optional()
              .nullable(),
            prev: z
              .string()
              .describe(
                'Cursor pointing to the previous page in the list of results.'
              )
              .max(16000)
              .optional()
              .nullable(),
          })
          .describe(
            'Cursor strings that point to the next page, previous page, or both.'
          )
          .optional(),
        hasNext: z
          .boolean()
          .describe(
            'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
          )
          .optional()
          .nullable(),
      })
      .describe('Paging metadata.')
      .optional(),
  });
})();
export const TerminateJobRequest = z.object({
  jobId: z
    .string()
    .describe('ID of the job to terminate.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const TerminateJobResponse = (() => {
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
        }),
        z.object({
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          fieldPath: z
            .string()
            .describe(
              'Path to the field containing the value to resolve.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`.'
            )
            .max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          text: z.string().describe('Text value.').max(1000),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          numeric: z.number().describe('Number value.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          add: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Adds the specified expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          sum: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Calculates the total sum of multiple expressions.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          subtract: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract `secondExpression` from.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to subtract from `firstExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Subtracts 1 expression from another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          multiply: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe('Multiplies multiple expressions together.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          divide: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression`.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe('Divides 1 expression by another.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          abs: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to find the absolute value of.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Finds the absolute value of an expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          mod: z
            .object({
              firstExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide by `secondExpression` to find the remainder.\n\nExpression must resolve to a number.'
                )
                .optional(),
              secondExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to divide `firstExpression` by.\n\nExpression must resolve to a non-zero number.'
                )
                .optional(),
            })
            .describe(
              'Finds the remainder when dividing 1 expression by another.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          floor: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round down to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression down to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          ceil: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to round up to the nearest whole number.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Rounds an expression up to the nearest whole number.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          concat: z
            .object({
              expressions: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Joins multiple expressions together to create a string.'
            ),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          stringify: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe('Expression to convert to a string.')
                .optional(),
            })
            .describe('Converts an expression to a string.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toLower: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to lowercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to lowercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          substring: z.never().optional(),
          length: z.never().optional(),
          toUpper: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to convert to uppercase.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Converts an expression to uppercase.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          length: z.never().optional(),
          substring: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to extract a substring from.\n\nExpression must resolve to a string.'
                )
                .optional(),
              startExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Starting position of the substring to extract, specified in zero-based indexing.\n\nExpression must resolve to a number.'
                )
                .optional(),
              lengthExpression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Number of characters to extract from the starting position.\n\nExpression must resolve to a number.'
                )
                .optional(),
            })
            .describe('Extracts a portion of a string expression.'),
        }),
        z.object({
          fieldPath: z.never().optional(),
          text: z.never().optional(),
          numeric: z.never().optional(),
          add: z.never().optional(),
          sum: z.never().optional(),
          subtract: z.never().optional(),
          multiply: z.never().optional(),
          divide: z.never().optional(),
          abs: z.never().optional(),
          mod: z.never().optional(),
          floor: z.never().optional(),
          ceil: z.never().optional(),
          concat: z.never().optional(),
          stringify: z.never().optional(),
          toLower: z.never().optional(),
          toUpper: z.never().optional(),
          substring: z.never().optional(),
          length: z
            .object({
              expression: z
                .lazy(
                  () =>
                    comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                )
                .describe(
                  'Expression to count the total number of characters of.\n\nExpression must resolve to a string.'
                )
                .optional(),
            })
            .describe('Finds the length of a string expression.'),
        }),
      ])
    );
  let comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema: z.ZodType<any> =
    z.intersection(
      z.object({}),
      z.xor([
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
        }),
        z.object({
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          include: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to include in the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, includes only the specified field in the result. All other fields are excluded.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z.never().optional(),
          exclude: z
            .object({
              fieldName: z
                .string()
                .describe(
                  'Key of the field to exclude from the result.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'When specified, excludes the specified field from the result. All other fields are included.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          projectNested: z.never().optional(),
          reshape: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the field to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              expression:
                comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                  .describe(
                    'Expression to resolve. The result of the expression becomes the value of the new field.'
                  )
                  .optional(),
            })
            .describe(
              'Reshapes a new field based on the specified expression. The field used by the expression is not included in the result.'
            ),
        }),
        z.object({
          include: z.never().optional(),
          exclude: z.never().optional(),
          reshape: z.never().optional(),
          projectNested: z
            .object({
              resultFieldName: z
                .string()
                .describe(
                  'Key of the parent field for the nested fields.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                )
                .max(1000)
                .optional(),
              fields: z
                .array(
                  z.lazy(
                    () =>
                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                  )
                )
                .max(1000)
                .optional(),
            })
            .describe(
              'Creates nested fields by including, excluding, or reshaping fields.'
            ),
        }),
      ])
    );
  return z.object({
    job: z
      .intersection(
        z.object({
          _id: z
            .string()
            .describe('Job ID.')
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional(),
          startedAt: z
            .date()
            .describe('When the job was submitted.')
            .optional()
            .nullable(),
          status: z
            .enum([
              'UNINITIALIZED',
              'INITIALIZING',
              'IN_PROGRESS',
              'COMPLETED',
              'FAILED',
              'PARTIALLY_SUCCESSFUL',
            ])
            .describe('Current job status.')
            .optional(),
          source: z
            .intersection(
              z.object({}),
              z.xor([
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z.never().optional(),
                }),
                z.object({
                  localization: z.never().optional(),
                  file: z.never().optional(),
                  wixDataCollection: z
                    .intersection(
                      z.object({
                        collectionId: z
                          .string()
                          .describe('ID of the data collection.')
                          .min(1)
                          .max(256)
                          .optional(),
                        filter: z
                          .record(z.string(), z.any())
                          .describe(
                            'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).\nDeprecated: Use `filter_query.filter` instead.'
                          )
                          .optional()
                          .nullable(),
                        fields: z.array(z.string()).optional(),
                      }),
                      z.xor([
                        z.object({
                          filterQuery: z.never().optional(),
                          aggregationQuery: z.never().optional(),
                        }),
                        z.object({
                          aggregationQuery: z.never().optional(),
                          filterQuery: z
                            .object({
                              filter: z
                                .record(z.string(), z.any())
                                .describe(
                                  'Filter to apply to the items. Only items that pass the filter are moved.\n\nLearn more about building a query filter using [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).'
                                )
                                .optional()
                                .nullable(),
                              fields: z.array(z.string()).optional(),
                            })
                            .describe(
                              'Filter and field selection to apply to the collection items.'
                            ),
                        }),
                        z.object({
                          filterQuery: z.never().optional(),
                          aggregationQuery: z
                            .object({
                              aggregationPipeline: z
                                .intersection(
                                  z.object({
                                    stages: z
                                      .array(
                                        z.intersection(
                                          z.object({}),
                                          z.xor([
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                            }),
                                            z.object({
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              group: z
                                                .object({
                                                  groupIds: z
                                                    .array(
                                                      z.object({
                                                        key: z
                                                          .string()
                                                          .describe(
                                                            "Name of the field to group items by.\n\nThis becomes the field name in the result's `_id` property."
                                                          )
                                                          .max(1000)
                                                          .optional(),
                                                        expression:
                                                          comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                            .describe(
                                                              "Expression to determine the grouping value. Items whose expression resolves to the same value are grouped together in the result item's `_id` property."
                                                            )
                                                            .optional(),
                                                      })
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                  accumulators: z
                                                    .array(
                                                      z.intersection(
                                                        z.object({
                                                          resultFieldName: z
                                                            .string()
                                                            .describe(
                                                              'Field key in the output item to store the result in.'
                                                            )
                                                            .max(1000)
                                                            .optional(),
                                                        }),
                                                        z.xor([
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                          }),
                                                          z.object({
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            avg: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to calculate the group's average value.\n\nExpression must resolve to a number."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Calculates the average value across all items in the group based on the specified expression.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to find the group's minimum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the minimum value across all items in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to find the group's maximum value.\n\nExpression must resolve to a comparable value, such as a number or string."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the maximum value across all items in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      "Expression to calculate the group's total sum.\n\nExpression must resolve to a number."
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Calculates the sum of the specified expression across all items in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      'Expression to find the first item in the group.'
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the first item in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      'Expression to find the last item in the group.'
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Finds the last item in the group.'
                                                              ),
                                                          }),
                                                          z.object({
                                                            avg: z
                                                              .never()
                                                              .optional(),
                                                            min: z
                                                              .never()
                                                              .optional(),
                                                            max: z
                                                              .never()
                                                              .optional(),
                                                            sum: z
                                                              .never()
                                                              .optional(),
                                                            first: z
                                                              .never()
                                                              .optional(),
                                                            last: z
                                                              .never()
                                                              .optional(),
                                                            push: z
                                                              .object({
                                                                expression:
                                                                  comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSchema
                                                                    .describe(
                                                                      'Expression to collect items into an array.'
                                                                    )
                                                                    .optional(),
                                                              })
                                                              .describe(
                                                                'Collects values from all items in the group into an array.'
                                                              ),
                                                          }),
                                                        ])
                                                      )
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Groups aggregated items to new result items.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              filter: z
                                                .record(z.string(), z.any())
                                                .describe(
                                                  'Aggregation filter. Only items that match the filter are processed.\n\nLearn more about [filters in API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).\n\n> **Note:** The values you provide for each filter field must adhere to that field\'s data type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              sort: z
                                                .object({
                                                  values: z
                                                    .array(
                                                      z.object({
                                                        fieldName: z
                                                          .string()
                                                          .describe(
                                                            'Name of the field to sort by.'
                                                          )
                                                          .min(1)
                                                          .max(1000)
                                                          .optional(),
                                                        order: z
                                                          .enum(['ASC', 'DESC'])
                                                          .describe(
                                                            'Sort order.'
                                                          )
                                                          .optional(),
                                                      })
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Sorting preferences.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              projection: z
                                                .object({
                                                  fields: z
                                                    .array(
                                                      comWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldSchema
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Transforms items by including, excluding, or reshaping fields.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              objectToArray: z
                                                .object({
                                                  objectFieldName: z
                                                    .string()
                                                    .describe(
                                                      'Key of the object field to convert to an array.\n\nUse dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                  destinationFieldName: z
                                                    .string()
                                                    .describe(
                                                      'Key of the new array to create in the result item.\n\nLearn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Transforms an object into an array where each object property becomes a new array element containing the property's key and value, as well as all other properties from the original object."
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              skip: z.never().optional(),
                                              limit: z.never().optional(),
                                              unwindArray: z
                                                .object({
                                                  arrayFieldName: z
                                                    .string()
                                                    .describe(
                                                      'Key of the array field to unwind.\n\nUse dot notation to specify a nested array. For example, `user.products` or `product.colors`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).'
                                                    )
                                                    .max(1000)
                                                    .optional(),
                                                })
                                                .describe(
                                                  'Creates a result item for each array element. Each result contains the full original item, with the array field replaced by an element whose key is the array name and whose value is the array element.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              limit: z.never().optional(),
                                              skip: z
                                                .number()
                                                .int()
                                                .describe(
                                                  'Number of results to skip from the beginning of the result set.'
                                                ),
                                            }),
                                            z.object({
                                              group: z.never().optional(),
                                              filter: z.never().optional(),
                                              sort: z.never().optional(),
                                              projection: z.never().optional(),
                                              objectToArray: z
                                                .never()
                                                .optional(),
                                              unwindArray: z.never().optional(),
                                              skip: z.never().optional(),
                                              limit: z
                                                .number()
                                                .int()
                                                .describe(
                                                  'Maximum number of results to return.'
                                                ),
                                            }),
                                          ])
                                        )
                                      )
                                      .max(100)
                                      .optional(),
                                  }),
                                  z.xor([
                                    z.object({
                                      paging: z.never().optional(),
                                      cursorPaging: z.never().optional(),
                                    }),
                                    z.object({
                                      cursorPaging: z.never().optional(),
                                      paging: z
                                        .object({
                                          limit: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Number of items to load.'
                                            )
                                            .min(0)
                                            .optional()
                                            .nullable(),
                                          offset: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Number of items to skip in the current sort order.'
                                            )
                                            .min(0)
                                            .optional()
                                            .nullable(),
                                        })
                                        .describe(
                                          'Paging options to limit and skip the number of results.\n\nLearn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).'
                                        ),
                                    }),
                                    z.object({
                                      paging: z.never().optional(),
                                      cursorPaging: z
                                        .object({
                                          limit: z
                                            .number()
                                            .int()
                                            .describe(
                                              'Number of items to load.'
                                            )
                                            .min(0)
                                            .max(1000)
                                            .optional()
                                            .nullable(),
                                          cursor: z
                                            .string()
                                            .describe(
                                              "Pointer to the next or previous page in the list of results.\n\nYou can get the relevant cursor token\nfrom the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                                            )
                                            .max(150000)
                                            .optional()
                                            .nullable(),
                                        })
                                        .describe(
                                          'Cursor token referring to a page of results.\n\nNot used in the first request. Subsequent requests use the cursor token and not `filter` or `sort`.'
                                        ),
                                    }),
                                  ])
                                )
                                .describe(
                                  'Aggregation pipeline to run on the collection.'
                                )
                                .optional(),
                              fields: z
                                .array(
                                  z.object({
                                    key: z
                                      .string()
                                      .describe(
                                        'Field ID.\n\nIf the field type is `Array`, specify the item index. If the field type is `Object`, specify the field path. Use dot notation to specify nested fields, for example: `data.address.city`.'
                                      )
                                      .max(1024)
                                      .optional(),
                                    displayName: z
                                      .string()
                                      .describe(
                                        'Field display name.\n\nWhen moving items to CSV files, use this to set the header of the target column.'
                                      )
                                      .max(1024)
                                      .optional(),
                                    fieldType: z
                                      .enum([
                                        'ANY',
                                        'STRING',
                                        'NUMBER',
                                        'BOOLEAN',
                                        'DATE',
                                        'DATETIME',
                                        'BINARY',
                                        'OBJECT',
                                        'ARRAY',
                                        'URL',
                                        'WIX_MEDIA_URL',
                                        'WIX_MEDIA_IMAGE_URL',
                                        'WIX_MEDIA_VIDEO_URL',
                                        'WIX_MEDIA_DOCUMENT_URL',
                                        'IMAGE_URL',
                                        'VIDEO_URL',
                                      ])
                                      .describe(
                                        'Field data type. Default: `ANY`.\n\nLearn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).'
                                      )
                                      .optional(),
                                  })
                                )
                                .min(0)
                                .max(1000)
                                .optional(),
                            })
                            .describe(
                              'Aggregation pipeline to run on the collection.'
                            ),
                        }),
                      ])
                    )
                    .describe(
                      'Wix data collection.\n\nYou can move items from native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  file: z.never().optional(),
                  localization: z
                    .object({
                      languages: z.array(z.string()).min(2).max(64).optional(),
                    })
                    .describe(
                      'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z
                    .object({
                      format: z
                        .enum(['UNKNOWN', 'CSV', 'JSONL'])
                        .describe(
                          'File format. If not specified, automatically determined by Wix.'
                        )
                        .optional(),
                      fileId: z
                        .string()
                        .describe(
                          "File ID as returned in the `fileId` property of the Create File Upload URL method's response."
                        )
                        .max(512)
                        .optional(),
                      url: z
                        .string()
                        .describe(
                          'URL where the source file is uploaded. Automatically generated by Wix.'
                        )
                        .max(2048)
                        .optional(),
                    })
                    .describe(
                      'Source file.\n\nYou can import data from files in CSV or JSONL formats. Uploading a file with an invalid format causes the movement job to fail.\n\nTo upload a file, call Create File Upload Url ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/movement-jobs/create-file-upload-url) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-movement-jobs/create-file-upload-url)) and use the `uploadUrl` from the response. For example:\n\n`curl --request PUT --upload-file "${path_to_file}" "${uploadUrl}"`'
                    ),
                }),
              ])
            )
            .describe('Source to move data from.')
            .optional(),
          destination: z
            .intersection(
              z.object({}),
              z.xor([
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z.never().optional(),
                }),
                z.object({
                  localization: z.never().optional(),
                  file: z.never().optional(),
                  wixDataCollection: z
                    .object({
                      collectionId: z
                        .string()
                        .describe('ID of the destination collection.')
                        .max(256)
                        .optional(),
                      writePolicy: z
                        .enum(['OVERWRITE', 'SKIP_EXISTING', 'TRUNCATE_BEFORE'])
                        .describe(
                          'When items already exist in the destination collection, the data writing policy.\n\nDefault: `OVERWRITE`.'
                        )
                        .optional(),
                    })
                    .describe(
                      'Wix data collection.\n\nYou can move items to native Wix collections, [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code), and [external database collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  file: z.never().optional(),
                  localization: z
                    .object({
                      languages: z.array(z.string()).min(2).max(64).optional(),
                    })
                    .describe(
                      'Localized CMS content. Available when the site has [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) installed.\n\nLearn more about working with [translated CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).'
                    ),
                }),
                z.object({
                  wixDataCollection: z.never().optional(),
                  localization: z.never().optional(),
                  file: z
                    .object({
                      format: z
                        .enum(['UNKNOWN', 'CSV', 'JSONL'])
                        .describe('File format.')
                        .optional(),
                      fileName: z
                        .string()
                        .describe('File name.')
                        .max(512)
                        .optional()
                        .nullable(),
                      url: z
                        .string()
                        .describe('File download URL.')
                        .max(2048)
                        .optional(),
                    })
                    .describe('Downloadable file with the moved items.'),
                }),
              ])
            )
            .describe('Destination to move data to.')
            .optional(),
          name: z.string().describe('Job name.').max(1024).optional(),
          progress: z
            .object({
              current: z
                .number()
                .int()
                .describe('Number of units already processed.')
                .optional(),
              total: z
                .number()
                .int()
                .describe('Total number of units to move.')
                .optional()
                .nullable(),
              itemsRejected: z
                .number()
                .int()
                .describe(
                  'Number of items that failed to move to the destination.'
                )
                .optional(),
              itemsSuccessful: z
                .number()
                .int()
                .describe(
                  'Number of items successfully moved to the destination.'
                )
                .optional(),
            })
            .describe(
              'When the job `status` is `IN_PROGRESS`, the progress details.'
            )
            .optional(),
          finishedAt: z
            .date()
            .describe(
              'Job finish time.\n\nA job is considered finished when its `status` updates to `COMPLETED`, `FAILED`, or `PARTIALLY_SUCCESSFUL`.'
            )
            .optional()
            .nullable(),
          error: z
            .object({
              code: z.string().describe('Error code.').optional(),
              description: z
                .string()
                .describe('Description of the error.')
                .optional(),
              data: z
                .record(z.string(), z.any())
                .describe('Data related to the error.')
                .optional()
                .nullable(),
            })
            .describe('Error information.')
            .optional(),
          sourceSiteId: z
            .string()
            .describe(
              'When moving data from a Wix data collection, the source site ID.\n\nBy default, the source site is the current site. To move data from [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional(),
          destinationSiteId: z
            .string()
            .describe(
              'When moving data to a Wix data collection, the destination site ID.\n\nBy default, the destination site is the current site. To move data to [any site in the same Wix Account](https://support.wix.com/en/article/managing-multiple-sites-under-one-account), specify the site ID, which you can retrieve by calling [Get App Instance](https://dev.wix.com/docs/rest/app-management/app-instance/get-app-instance).\n\n> **Note**: You can specify the ID of a source site or destination site, but not both.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional(),
          logsRecorded: z
            .number()
            .int()
            .describe('Number of recorded logs.')
            .optional(),
          scheduleId: z
            .string()
            .describe(
              'Sync Schedule ID, if the job was triggered by a sync schedule.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          extendedFields: z
            .object({
              namespaces: z
                .record(z.string(), z.record(z.string(), z.any()))
                .describe(
                  'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
                )
                .optional(),
            })
            .describe(
              'Extended fields for custom metadata added by applications.'
            )
            .optional(),
          workflowId: z
            .string()
            .describe(
              'Workflow ID, if the job was created as a child step of a workflow.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
        }),
        z.xor([
          z.object({ partiallySuccessfulOptions: z.never().optional() }),
          z.object({
            partiallySuccessfulOptions: z
              .object({
                cause: z
                  .string()
                  .describe('Reason the job was partially successful.')
                  .max(1000)
                  .optional(),
              })
              .describe(
                "When the job's `status` is `PARTIALLY_SUCCESSFUL`, the additional details."
              ),
          }),
        ])
      )
      .describe('Details of the terminated job.')
      .optional(),
  });
})();
export const ListMovementLogsRequest = z.object({
  jobId: z
    .string()
    .describe('ID of the job for which to list logs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe('Maximum number of items to return in the results.')
            .min(0)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe(
              "Pointer to the next or previous page in the list of results.\n\nPass the relevant cursor token from the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe('Paging metadata.')
        .optional(),
    })
    .optional(),
});
export const ListMovementLogsResponse = z.object({
  logs: z
    .array(
      z.object({
        sourceItemId: z
          .string()
          .describe(
            'ID of the item in the source, such as a Wix Data Item or a row number in a CSV file.'
          )
          .max(512)
          .optional(),
        failure: z
          .object({
            code: z.string().describe('Error code.').optional(),
            description: z
              .string()
              .describe('Description of the error.')
              .optional(),
            data: z
              .record(z.string(), z.any())
              .describe('Data related to the error.')
              .optional()
              .nullable(),
          })
          .describe('Details about the failure if moving the item fails.')
          .optional(),
        details: z
          .record(z.string(), z.any())
          .describe(
            'Additional details provided when moving the item succeeds with details.\n\n> **Note**: Each destination type determines the structure of its `details` object.'
          )
          .optional()
          .nullable(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in current page.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Paging metadata.')
    .optional(),
});
